// Preisdaten: erzeugt aus bestand.xlsx (tools/build_shop_from_xlsx.py) — die
// Excel-Datei ist die Pflege-Zentrale des Webshops: Preise, Bezeichnungen,
// Typen und Gruppen werden dort gepflegt und beim nächsten Build übernommen.
// Preise in Cent, netto zzgl. MwSt. und Versand. Jede Art.-Nr. erscheint genau einmal.
export const PRICE_STAND = 'Januar 2026';

export const PRICE_GROUPS = [
  {
    "title": "Antennen 60cm - 2,4m",
    "items": [
      {
        "sku": "036006",
        "name": "125cm Alu-Offset mit AZ/EL-Halter (anthrazit)",
        "ref": "OP125A",
        "price": 18900
      },
      {
        "sku": "036054",
        "name": "150cm Alu-Offset mit AZ/EL-Halter (lichtgrau)",
        "ref": "OP150L",
        "price": 31000
      },
      {
        "sku": "036063",
        "name": "180cm GFK-Kunststoff-Offsetantenne mit AZ/EL-Halter  - lichtgrau",
        "ref": "OP180L",
        "price": 91000
      },
      {
        "sku": "101000",
        "name": "Antennenheizung inkl.Steuerung für OPV180",
        "ref": "HEIZUNG180",
        "price": 220000
      },
      {
        "sku": "067005",
        "name": "Nachrüstsatz (lichtgrau) Polarmount für OP125,OP150",
        "ref": "PM125/150L",
        "price": 3100
      },
      {
        "sku": "055029",
        "name": "2-fach Alu-Multifeedschiene für OPV85,OPV100 - Aufnahme 23 und 40mm für min.6° Abstand",
        "ref": "MFH2G",
        "price": 1100
      },
      {
        "sku": "056003",
        "name": "C-Band Feedhalter für OP125,OP150",
        "ref": "FH125C",
        "price": 1900
      },
      {
        "sku": "055035",
        "name": "4-fach Alu-Multifeedschiene für OP125,OP150 - Aufnahme 23mm für min.3° Abstand",
        "ref": "MFH4G23",
        "price": 2100
      },
      {
        "sku": "055036",
        "name": "4-fach Alu-Multifeedschiene für OP125,OP150- Aufnahme 40mm für min.3° Abstand",
        "ref": "MFH4G40",
        "price": 1900
      },
      {
        "sku": "036053",
        "name": "125cm Alu-Offset mit AZ/EL-Halter  (lichtgrau)",
        "ref": "OP125L",
        "price": 18900
      },
      {
        "sku": "067004",
        "name": "Nachrüstsatz (anthrazit) Polarmount für OP125,OP150",
        "ref": "PM125/150A",
        "price": 3100
      },
      {
        "sku": "036066",
        "name": "240cm GFK-Kunststoff-Offsetantenne mit AZ/EL-Halter - lichtgrau",
        "ref": "OP240L",
        "price": 320000
      },
      {
        "sku": "036068",
        "name": "Alu-Offset-Antenne - 65cm - lichtgrau",
        "ref": "OP65L",
        "price": 4900
      },
      {
        "sku": "036069",
        "name": "Alu-Offset-Antenne - 65cm - ziegelrot",
        "ref": "OP65R",
        "price": 4900
      },
      {
        "sku": "036067",
        "name": "Alu-Offset-Antenne - 65cm - graphit",
        "ref": "OP65A",
        "price": 4900
      },
      {
        "sku": "067003",
        "name": "Polarmount für OPV85 / OPV100",
        "ref": "PM85/100",
        "price": 2900
      },
      {
        "sku": "036048",
        "name": "10x Profi Alu-Offset-Antenne - 85cm - ziegelrot",
        "ref": "OPBV85R",
        "price": 61000
      },
      {
        "sku": "036046",
        "name": "10x Profi Alu-Offset-Antenne - 85cm - graphit",
        "ref": "OPBV85A",
        "price": 61000
      },
      {
        "sku": "036047",
        "name": "10x Profi Alu-Offset-Antenne - 85cm - lichtgrau",
        "ref": "OPBV85L",
        "price": 61000
      },
      {
        "sku": "036049",
        "name": "10x Profi Alu-Offset-Antenne - 100cm - graphit",
        "ref": "OPBV100A",
        "price": 81000
      },
      {
        "sku": "036050",
        "name": "10x Profi Alu-Offset-Antenne - 100cm - lichtgrau",
        "ref": "OPBV100L",
        "price": 81000
      },
      {
        "sku": "036051",
        "name": "10x Profi Alu-Offset-Antenne - 100cm - ziegelrot",
        "ref": "OPBV100R",
        "price": 81000
      },
      {
        "sku": "036040",
        "name": "Profi Alu-Offset-Antenne - 85cm - ziegelrot",
        "ref": "OPV85R",
        "price": 6900
      },
      {
        "sku": "036044",
        "name": "Profi Alu-Offset-Antenne - 100cm - graphit",
        "ref": "OPV100A",
        "price": 8900
      },
      {
        "sku": "036043",
        "name": "Profi Alu-Offset-Antenne - 100cm - lichtgrau",
        "ref": "OPV100L",
        "price": 8900
      },
      {
        "sku": "036045",
        "name": "Profi Alu-Offset-Antenne - 100cm - ziegelrot",
        "ref": "OPV100R",
        "price": 8900
      },
      {
        "sku": "036042",
        "name": "Profi Alu-Offset-Antenne - 85cm - lichtgrau",
        "ref": "OPV85L",
        "price": 6900
      },
      {
        "sku": "036041",
        "name": "Profi Alu-Offset-Antenne - 85cm - graphit",
        "ref": "OPV85A",
        "price": 6900
      },
      {
        "sku": "036079",
        "name": "Profi Alu-Offset-Antenne - 100cm - ,graphit",
        "ref": "OP100SE-A",
        "price": 10400
      },
      {
        "sku": "036090",
        "name": "Profi Alu-Offset-Antenne - 85cm - ,lichtgrau",
        "ref": "OP85SE-L",
        "price": 7900
      },
      {
        "sku": "036083",
        "name": "Profi Alu-Offset-Antenne - 85cm - ,graphit",
        "ref": "OP85SE-A",
        "price": 7900
      },
      {
        "sku": "036080",
        "name": "Profi Alu-Offset-Antenne - 100cm - ,lichtgrau",
        "ref": "OP100SE-L",
        "price": 10400
      },
      {
        "sku": "036081",
        "name": "Profi Alu-Offset-Antenne - 100cm - ,ziegelrot",
        "ref": "OP100SE-R",
        "price": 10400
      },
      {
        "sku": "036085",
        "name": "Profi Alu-Offset-Antenne - 85cm - ,ziegelrot",
        "ref": "OP85SE-R",
        "price": 7900
      }
    ]
  },
  {
    "title": "Kathrein- / Astro-Antennen / Adapter",
    "items": [
      {
        "sku": "055021",
        "name": "2 x 23mm Feedhalter - 2 Satpositionen für 6° Abstand",
        "ref": "MFAK2-23A",
        "price": 2900
      },
      {
        "sku": "055022",
        "name": "2 x 40mm Feedhalter - 2 Satpositionen für 6° Abstand",
        "ref": "MFAK2-40A",
        "price": 2900
      },
      {
        "sku": "023020",
        "name": "23mm Feedhalter für 1 Satposition",
        "ref": "EFAK123",
        "price": 2500
      },
      {
        "sku": "023021",
        "name": "40mm Feedhalter für 1 Satposition",
        "ref": "EFAK140",
        "price": 2500
      },
      {
        "sku": "023012",
        "name": "60mm Feedhalter für 1 Satposition",
        "ref": "EFAK160",
        "price": 2500
      },
      {
        "sku": "023022",
        "name": "Feedhalter für C-Band-Speisesystem",
        "ref": "EFAK1C",
        "price": 2900
      },
      {
        "sku": "056001",
        "name": "23mm Feedhalter zur Erweiterung derVMS-Systeme",
        "ref": "FH23",
        "price": 1500
      },
      {
        "sku": "056002",
        "name": "40mm Feedhalter zur Erweiterung derVMS-Systeme",
        "ref": "FH40",
        "price": 1500
      },
      {
        "sku": "055017",
        "name": "2 x 23mm Feedhalter - erweiterbar bis 5 Satpositionen für 3° Abstand - für 80 & 90cm Antennnen",
        "ref": "VMSK90-23",
        "price": 4900
      },
      {
        "sku": "055019",
        "name": "2 x 23mm Feedhalter - erweiterbar bis 5 Satpositionen für 3° Abstand - für 120cm Antennnen",
        "ref": "VMSK120-23",
        "price": 4900
      },
      {
        "sku": "055018",
        "name": "2 x 40mm Feedhalter - erweiterbar bis 3 Satpositionen für 6° Abstand - für 80 & 90cm Antennnen",
        "ref": "VMSK90-40",
        "price": 4900
      },
      {
        "sku": "055020",
        "name": "2 x 40mm Feedhalter - erweiterbar bis 3 Satpositionen für 6° Abstand - für 120cm Antennnen",
        "ref": "VMSK120-40",
        "price": 4900
      },
      {
        "sku": "055023",
        "name": "MULTIFEED-Adapterplatte für CAS80 und CAS 90",
        "ref": "ZAS90",
        "price": 1850
      },
      {
        "sku": "036062",
        "name": "Alu-Offset-Antenne - 90cm - ziegelrot",
        "ref": "",
        "price": 21800
      },
      {
        "sku": "036061",
        "name": "Alu-Offset-Antenne - 90cm - lichtgrau",
        "ref": "",
        "price": 21800
      },
      {
        "sku": "036060",
        "name": "Alu-Offset-Antenne - 90cm - graphit",
        "ref": "",
        "price": 21800
      },
      {
        "sku": "036002",
        "name": "Alu-Offset-Antenne - 80cm - graphit",
        "ref": "",
        "price": 15500
      },
      {
        "sku": "036058",
        "name": "Alu-Offset-Antenne - 80cm - lichtgrau",
        "ref": "",
        "price": 15500
      },
      {
        "sku": "036056",
        "name": "Alu-Offset-Antenne - 60cm - graphit",
        "ref": "CAS60",
        "price": 9240
      },
      {
        "sku": "036059",
        "name": "Alu-Offset-Antenne - 80cm - ziegelrot",
        "ref": "",
        "price": 15500
      },
      {
        "sku": "036077",
        "name": "Alu-Offset-Antenne - 120cm - graphit",
        "ref": "",
        "price": 71900
      },
      {
        "sku": "036082",
        "name": "Alu-Offset-Antenne - 120cm - ziegelrot",
        "ref": "",
        "price": 71900
      },
      {
        "sku": "036005",
        "name": "Alu-Offset-Antenne - 120cm - lichtgrau",
        "ref": "",
        "price": 71900
      },
      {
        "sku": "068006",
        "name": "AZ/EL-Halterung für CAS120",
        "ref": "ZAS120",
        "price": 20300
      },
      {
        "sku": "001230",
        "name": "Wideband-LNB,10,70-12,75GHz,zwei Ausgänge,LO 10,4",
        "ref": "UAS582",
        "price": 17200
      },
      {
        "sku": "001069",
        "name": "Single-LNB,10,70-12,75GHz,ein Ausgang (14/18V,0/22kHz),80mA",
        "ref": "UAS571",
        "price": 5900
      },
      {
        "sku": "001229",
        "name": "Quattro LNB,10,70-12,75GHz,vier Ausgänge (V-low,H-low,V-high,H-high),150mA",
        "ref": "UAS584",
        "price": 11600
      },
      {
        "sku": "001231",
        "name": "Twin-LNB,10,70-12,75GHz,zwei Ausgänge schaltbar (14/18V,0/22kHz),175mA",
        "ref": "UAS572",
        "price": 8500
      }
    ]
  },
  {
    "title": "MasterFocus-Antennen",
    "items": [
      {
        "sku": "068001",
        "name": "Fixmount MASTER-focus 90cm Antenne",
        "ref": "FM90MF",
        "price": 2500
      },
      {
        "sku": "067001",
        "name": "Polarmount  MASTER-focus 90cm,ohne Motor",
        "ref": "PM90MF",
        "price": 7100
      },
      {
        "sku": "063012",
        "name": "Getriebemotor MASTER-focus  Polarmount 90 / 120cm",
        "ref": "MMF",
        "price": 7600
      },
      {
        "sku": "091003",
        "name": "Ritzel Getriebemotor und Azimuthlock für Polarmount 90 / 120cm",
        "ref": "RITZEL",
        "price": 800
      },
      {
        "sku": "023018",
        "name": "Drehadapter für Feedhorn MASTER-focus",
        "ref": "MFDA",
        "price": 1200
      },
      {
        "sku": "054003",
        "name": "Feedhorn mit Drehadapter für MASTER-focus 55,90,120cm",
        "ref": "MFFEED",
        "price": 3900
      },
      {
        "sku": "090001",
        "name": "Polarizer magnetisch  für  MASTER-focus",
        "ref": "MFPOL",
        "price": 2000
      },
      {
        "sku": "036017",
        "name": "90cm Antenne,Fixmount,Subreflektor,Feed,Raincover",
        "ref": "MF90",
        "price": 13900
      },
      {
        "sku": "036027",
        "name": "90cm Antenne,Fixmount,Multifeed mit 2 x 40mm Feedhalter",
        "ref": "MF90M40",
        "price": 13700
      },
      {
        "sku": "036025",
        "name": "90cm Antenne,Fixmount,Multifeed mit 2 x 23mm Feedhalter",
        "ref": "MF90M23",
        "price": 13700
      },
      {
        "sku": "055006",
        "name": "Multifeed-SystemNachrüstsatz,2x23mmFeedhalterfür3°Abstand",
        "ref": "MFS9023",
        "price": 4500
      },
      {
        "sku": "055007",
        "name": "Multifeed-System Nachrüstsatz,2 x 40mm Feedhalter für 6° Abstand",
        "ref": "MFS9040",
        "price": 4500
      }
    ]
  },
  {
    "title": "Beheizte SAT-Antennen",
    "items": [
      {
        "sku": "087006",
        "name": "Antenne 125cm - anthrazit - mit Heizung (670W)",
        "ref": "HSA-125-A",
        "price": 106900
      },
      {
        "sku": "087007",
        "name": "Antenne 125cm - lichtgrau - mit Heizung (670W)",
        "ref": "HSA-125-L",
        "price": 99900
      },
      {
        "sku": "087025",
        "name": "Antenne 150cm - lichtgrau - mit Heizung (755W)",
        "ref": "HSA-150-L",
        "price": 134900
      },
      {
        "sku": "087020",
        "name": "Feedheizung - großes Feed für bessere Empfangsqualität - 24V / 25W",
        "ref": "HSA-FHS-1",
        "price": 15900
      },
      {
        "sku": "087027",
        "name": "Feedheizung - kleines Feed - multifeed-fähig für Anlagen 6°  - 24V / 25W",
        "ref": "HSA-FHS-5",
        "price": 15900
      },
      {
        "sku": "227000",
        "name": "Netzteil Feedheizung (wird benötigt,wenn mehr als eine Feedheizung pro HSA1650 betrieben werden soll)",
        "ref": "NTFEED",
        "price": 12900
      },
      {
        "sku": "087021",
        "name": "Universelle Steuerung für beheizbare SAT-Antennen",
        "ref": "HSA1650",
        "price": 39900
      },
      {
        "sku": "087026",
        "name": "Antenne 120cm CAS120 - lichtgrau - mit Heizung (675W),inkl.ZAS120",
        "ref": "",
        "price": 149900
      },
      {
        "sku": "087028",
        "name": "Antenne 120cm CAS120 - anthrazit - mit Heizung (675W),inkl.ZAS120",
        "ref": "",
        "price": 149900
      },
      {
        "sku": "087029",
        "name": "Antenne 180cm OP180L - lichtgrau - mit Heizung (800W)",
        "ref": "HSA-180-L",
        "price": 209900
      },
      {
        "sku": "087019",
        "name": "Kathrein-Antenne 90cm - ziegelrot - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "",
        "price": 95900
      },
      {
        "sku": "087015",
        "name": "Antenne 100cm - lichtgrau - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "HSA-100-L",
        "price": 78900
      },
      {
        "sku": "087017",
        "name": "Kathrein-Antenne 90cm - anthrazit - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "",
        "price": 95900
      },
      {
        "sku": "087018",
        "name": "Kathrein-Antenne 90cm - lichtgrau - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "",
        "price": 95900
      },
      {
        "sku": "087014",
        "name": "Antenne 100cm - anthrazit - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "HSA-100-A",
        "price": 78900
      },
      {
        "sku": "087016",
        "name": "Antenne 100cm - ziegelrot - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "HSA-100-R",
        "price": 78900
      },
      {
        "sku": "087008",
        "name": "Antenne 85cm - anthrazit - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "HSA-85-A",
        "price": 65900
      },
      {
        "sku": "087009",
        "name": "Antenne 85cm - lichtgrau - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "HSA-85-L",
        "price": 65900
      },
      {
        "sku": "087010",
        "name": "Antenne 85cm - ziegelrot - mit Heizung,inkl.Steuerung,Feuchte- undTemperatursensor",
        "ref": "HSA-85-R",
        "price": 65900
      }
    ]
  },
  {
    "title": "Zubehör / Adapter / Multifeed",
    "items": [
      {
        "sku": "055033",
        "name": "2-fach Multifeedschiene für OP125,OP150 - Aufnahme 23mm und 40mm,6°Abstand",
        "ref": "MFH2E",
        "price": 900
      },
      {
        "sku": "055034",
        "name": "4-fach Multifeedschiene für OP125,OP150 - Aufnahme 23mm und 40mm,6°Abstand",
        "ref": "MFH4E",
        "price": 1200
      },
      {
        "sku": "056004",
        "name": "C-Band Feedhalter für Gibertini OP125,OP150,OP180",
        "ref": "FEC-HALTER",
        "price": 3900
      },
      {
        "sku": "054002",
        "name": "55mm Primefocus-Rillenfeed C120",
        "ref": "FE55",
        "price": 1900
      },
      {
        "sku": "054008",
        "name": "23mm Offset-Lang-Feed C120 für 3° Multifeedlösungen",
        "ref": "FE23L",
        "price": 2300
      },
      {
        "sku": "055031",
        "name": "2-fach Alu-Universal-Multifeedschiene,Aufnahme 23 und 40mm für min.6° Abstand - Druckguß",
        "ref": "MFH-UNI",
        "price": 990
      },
      {
        "sku": "055001",
        "name": "2-fach Alu-Universal-Multifeedschiene,Aufnahme 23mm für min.6° Abstand",
        "ref": "MFH-UNI23",
        "price": 1200
      }
    ]
  },
  {
    "title": "Empfangskonverter",
    "items": [
      {
        "sku": "001048",
        "name": "(Inverto) 40mm Feed 9.75/10.60 0.95-2.150GHz 0,5dB",
        "ref": "UNIQS40",
        "price": 2100
      },
      {
        "sku": "166002",
        "name": "(Inverto) 23mm Feed 9.75/10.60 0.95-2.150GHz 0,6dB",
        "ref": "QUAD-MONO",
        "price": 5900
      },
      {
        "sku": "166003",
        "name": "(Inverto) 40mm Feed 9.75/10.60 0.95-2.150GHz 0,3dB",
        "ref": "OCTO",
        "price": 4900
      },
      {
        "sku": "001020",
        "name": "(Inverto) 23mm Feed 9.75/10.60 0.95-2.150GHz 0,6dB",
        "ref": "UNI23",
        "price": 1100
      },
      {
        "sku": "001012",
        "name": "(Inverto) C120 FL 9.75/10.60 0.95-2.150GHz 0,4dB",
        "ref": "UNIFL",
        "price": 1300
      },
      {
        "sku": "001049",
        "name": "(Inverto) 40mm Feed 9.75/10.60 0.95-2.150GHz 0,4dB",
        "ref": "UNI40",
        "price": 500
      },
      {
        "sku": "001045",
        "name": "(Inverto) 40mm Feed 9.75/10.60 0.95-2.150GHz 0,4dB",
        "ref": "UNIT40",
        "price": 1400
      },
      {
        "sku": "001046",
        "name": "(Inverto) 40mm Feed 9.75/10.60 0.95-2.150GHz 0,4dB",
        "ref": "UNIQ40",
        "price": 1400
      },
      {
        "sku": "166005",
        "name": "Einkabel-LNB 40mm Unicable,4x Unicable,2x Legacy",
        "ref": "UNICABLE",
        "price": 4900
      }
    ]
  },
  {
    "title": "Fibre-Glas-Empfangssysteme",
    "items": [
      {
        "sku": "001293",
        "name": "Kopfstelle für SAT/Terr.Signale mit optischem Ausgang,inkl.Breitband LNB",
        "ref": "IFOTX",
        "price": 16900
      },
      {
        "sku": "001238",
        "name": "Optische Abschlusseinheit,HF-Konverter für Multischalterbetrieb",
        "ref": "IFQUATTRO",
        "price": 13900
      },
      {
        "sku": "001239",
        "name": "Optische Abschlusseinheit,HF-Konverter für 4 Receiver",
        "ref": "IFQUAD",
        "price": 9900
      },
      {
        "sku": "001283",
        "name": "Netzteil IF-Quattro / Quad-Umsetzer",
        "ref": "IFNT20V",
        "price": 1400
      },
      {
        "sku": "001246",
        "name": "Optische Kabelverbinder,2x FC/PC Kabelverbinder",
        "ref": "IFKUP",
        "price": 149
      },
      {
        "sku": "001259",
        "name": "Optisches Dämpfungsglied,dämpft das Signal um 20dB",
        "ref": "IFDB20",
        "price": 990
      },
      {
        "sku": "001241",
        "name": "Optisches Dämpfungsglied,dämpft das Signal um 15dB",
        "ref": "IFDB15",
        "price": 990
      },
      {
        "sku": "001240",
        "name": "Optisches Dämpfungsglied,dämpft das Signal um 5dB",
        "ref": "IFDB5",
        "price": 990
      },
      {
        "sku": "001245",
        "name": "Optisches Dämpfungsglied,dämpft das Signal um 10dB",
        "ref": "IFDB10",
        "price": 990
      },
      {
        "sku": "001263",
        "name": "Optisches Kabel 15m,2x FC/PC Stecker",
        "ref": "IFOK15",
        "price": 1700
      },
      {
        "sku": "001250",
        "name": "Optisches Kabel 30m,2x FC/PC Stecker",
        "ref": "IFOK30",
        "price": 2200
      },
      {
        "sku": "001251",
        "name": "Optisches Kabel 20m,2x FC/PC Stecker",
        "ref": "IFOK20",
        "price": 2000
      },
      {
        "sku": "001237",
        "name": "Optisches Kabel 40m,2x FC/PC Stecker",
        "ref": "IFOK40",
        "price": 2800
      },
      {
        "sku": "001256",
        "name": "Optisches Kabel 50m,2x FC/PC Stecker",
        "ref": "IFOK50",
        "price": 4250
      },
      {
        "sku": "001236",
        "name": "Optisches Kabel 75m,2x FC/PC Stecker",
        "ref": "IFOK75",
        "price": 5400
      },
      {
        "sku": "001264",
        "name": "Optisches Kabel 200m,2x FC/PC Stecker",
        "ref": "IFOK200",
        "price": 13800
      },
      {
        "sku": "001272",
        "name": "Optisches -Kabel 25m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN25",
        "price": 4200
      },
      {
        "sku": "001271",
        "name": "Optisches -Kabel 3m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN3",
        "price": 1990
      },
      {
        "sku": "001265",
        "name": "Optisches Kabel 500m,2x FC/PC Stecker",
        "ref": "IFOK500",
        "price": 32900
      },
      {
        "sku": "001244",
        "name": "Optisches Kabel 100m,2x FC/PC Stecker",
        "ref": "IFOK100",
        "price": 6900
      },
      {
        "sku": "001276",
        "name": "Optisches -Kabel 400m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN400",
        "price": 54900
      },
      {
        "sku": "001277",
        "name": "Optisches -Kabel 500m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN500",
        "price": 57900
      },
      {
        "sku": "001270",
        "name": "Optisches -Kabel 100m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN100",
        "price": 13490
      },
      {
        "sku": "001269",
        "name": "Optisches -Kabel 50m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN50",
        "price": 8700
      },
      {
        "sku": "001285",
        "name": "Optisches -Kabel 150m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN150",
        "price": 15500
      },
      {
        "sku": "001273",
        "name": "Optisches -Kabel 75m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN75",
        "price": 10900
      },
      {
        "sku": "001274",
        "name": "Optisches -Kabel 200m,2x FC/PC Stecker,zur direktenVerlegung im Erdreich geeignet",
        "ref": "IFOKTWIN200",
        "price": 25900
      },
      {
        "sku": "001248",
        "name": "Optisches Kabel 1m,2x FC/PC Stecker",
        "ref": "IFOK1",
        "price": 800
      },
      {
        "sku": "001249",
        "name": "Optisches Kabel 3m,2x FC/PC Stecker",
        "ref": "IFOK3",
        "price": 900
      },
      {
        "sku": "001243",
        "name": "Optisches Kabel 5m,2x FC/PC Stecker",
        "ref": "IFOK5",
        "price": 1100
      },
      {
        "sku": "001247",
        "name": "Optisches Kabel 10m,2x FC/PC Stecker",
        "ref": "IFOK10",
        "price": 1200
      },
      {
        "sku": "001254",
        "name": "Messgerät für optische Messungen",
        "ref": "IFSCAN",
        "price": 6900
      },
      {
        "sku": "001253",
        "name": "OptischerVerteiler,4-Wege,1 Eingang und 4 Ausgänge,Signaldämpfung je Ausgang:ca.6,8dB",
        "ref": "IFV4",
        "price": 4500
      },
      {
        "sku": "001261",
        "name": "OptischerVerteiler,8-Wege,1 Eingang und 8 Ausgänge,Signaldämpfung je Ausgang:ca.10,6dB",
        "ref": "IFV8",
        "price": 9900
      },
      {
        "sku": "001242",
        "name": "OptischerVerteiler,2-Wege,1 Eingang und 2 Ausgänge,Signaldämpfung je Ausgang:ca.3,8dB",
        "ref": "IFV2",
        "price": 2400
      },
      {
        "sku": "001257",
        "name": "OptischerVerteiler,3-Wege,1 Eingang und 3 Ausgänge,Signaldämpfung je Ausgang:ca.4,8dB",
        "ref": "IFV3",
        "price": 3950
      }
    ]
  },
  {
    "title": "Multischalter Kathrein & Zubehör",
    "items": [
      {
        "sku": "002067",
        "name": "Sat-Verteilnetzverstärker,47-862 und 8x 950-2150MHz,",
        "ref": "VWS2900",
        "price": 23700
      },
      {
        "sku": "002068",
        "name": "Sat-Verteilnetzverstärker,47-862 und 8x 950-2150MHz,",
        "ref": "VWS2500",
        "price": 15800
      },
      {
        "sku": "015024",
        "name": "SAT-ZF-Verteiler,5x 2-fach in einem Gehäuse,kaskadierbar mit EXR2900er Serie",
        "ref": "EBX2520",
        "price": 6400
      },
      {
        "sku": "015025",
        "name": "SAT-ZF-Verteiler,9x 2-fach in einem Gehäuse,kaskadierbar mit EXR2900er Serie",
        "ref": "EBX2920",
        "price": 10900
      },
      {
        "sku": "138002",
        "name": "5-fach Steckverbinder F,passend für EXR25xx undVWS25xx",
        "ref": "EMU250",
        "price": 1180
      },
      {
        "sku": "138001",
        "name": "9-fach Steckverbinder F,passend für EXR29xx undVWS29xx",
        "ref": "EMU290",
        "price": 1790
      },
      {
        "sku": "100005",
        "name": "Multischalter,aktiv 5 6 inkl.Netzteil",
        "ref": "EXR156",
        "price": 9200
      },
      {
        "sku": "100008",
        "name": "Multischalter,aktiv 5 8 inkl.Netzteil",
        "ref": "EXR158",
        "price": 9700
      },
      {
        "sku": "100020",
        "name": "Multischalter,passiv 5 8 inkl.Netzteil",
        "ref": "EXR58ECO",
        "price": 10500
      },
      {
        "sku": "100007",
        "name": "Multischalter,aktiv 5 16 inkl.Netzteil",
        "ref": "EXR1516",
        "price": 14800
      },
      {
        "sku": "093048",
        "name": "Kaskade 9 8",
        "ref": "EXR2998",
        "price": 18900
      },
      {
        "sku": "093055",
        "name": "Kaskade 17 8",
        "ref": "EXR1718",
        "price": 37900
      },
      {
        "sku": "093049",
        "name": "9 8 inkl.Netzteil",
        "ref": "EXR2908",
        "price": 21600
      },
      {
        "sku": "021059",
        "name": "Kaskade, 5 4",
        "ref": "EXR2554",
        "price": 7500
      },
      {
        "sku": "093053",
        "name": "5 8 inkl.Netzteil",
        "ref": "EXR2508",
        "price": 11700
      },
      {
        "sku": "021060",
        "name": "Kaskade 5 8",
        "ref": "EXR2558",
        "price": 10500
      },
      {
        "sku": "093054",
        "name": "17 8 inkl.Netzteil",
        "ref": "EXR1708",
        "price": 41800
      }
    ]
  },
  {
    "title": "Multischalter Müller & Zubehör",
    "items": [
      {
        "sku": "021081",
        "name": "Multischalter 5 8 Terr.10dB / Sat 5dB mit 22kHz",
        "ref": "MMS58",
        "price": 5500
      },
      {
        "sku": "021079",
        "name": "Multischalter 17 16 Terr.5dB / SAT 5dB Terr.-26dB / Sat 5dB",
        "ref": "MMS1716",
        "price": 18900
      },
      {
        "sku": "059030",
        "name": "Netzteil 15V / 3300mA - Für die Spannungsversorgung von 4 LNBs",
        "ref": "NT153300",
        "price": 2900
      },
      {
        "sku": "021080",
        "name": "Sat-ZF-Verstärker,16 SAT-ZF-Ebenen,VerstärkungTerr.20dB / SAT 20dB",
        "ref": "SV1720",
        "price": 15900
      },
      {
        "sku": "021082",
        "name": "Sat-ZF-Verstärker,8 SAT-ZF-Ebenen,VerstärkungTerr.20dB / SAT 20dB",
        "ref": "SV920",
        "price": 13900
      }
    ]
  },
  {
    "title": "Multischalter JULTEC & Zubehör",
    "items": [
      {
        "sku": "237059",
        "name": "5 12 Terr.- / SAT - Terr.-21dB / SAT -3...+3dB",
        "ref": "JRM0512T",
        "price": 14000
      },
      {
        "sku": "237060",
        "name": "5 16 SAT -3dB SAT -3...+3dB",
        "ref": "JRM0516M",
        "price": 16100
      },
      {
        "sku": "237056",
        "name": "5 8 SAT -2dB SAT -3...+3dB",
        "ref": "JRM0508M",
        "price": 9900
      },
      {
        "sku": "237057",
        "name": "5 8 Terr.- / SAT - Terr.-18dB / SAT -3...+3dB",
        "ref": "JRM0508T",
        "price": 9900
      },
      {
        "sku": "237058",
        "name": "5 12 SAT -2dB SAT -3...+3dB",
        "ref": "JRM0512M",
        "price": 14000
      },
      {
        "sku": "237061",
        "name": "5 16 Terr.- / SAT - Terr.-22dB / SAT -3...+3dB",
        "ref": "JRM0516T",
        "price": 16100
      },
      {
        "sku": "237067",
        "name": "9 16 Terr.- / SAT - Terr.-22dB / SAT -8...0dB",
        "ref": "JRM0916T",
        "price": 27300
      },
      {
        "sku": "237065",
        "name": "9 12 Terr.- / SAT - Terr.-21dB / SAT -8...0dB",
        "ref": "JRM0912T",
        "price": 23500
      },
      {
        "sku": "237066",
        "name": "9 16 SAT -8dB SAT -8...0dB",
        "ref": "JRM0916M",
        "price": 27300
      },
      {
        "sku": "237064",
        "name": "9 12 SAT 3dB SAT -8...0dB",
        "ref": "JRM0912M",
        "price": 23500
      },
      {
        "sku": "237063",
        "name": "9 8 Terr.- / SAT - Terr.-18dB / SAT -8...0dB",
        "ref": "JRM0908T",
        "price": 17800
      },
      {
        "sku": "237062",
        "name": "9 8 SAT -2dB SAT -8...0dB",
        "ref": "JRM0908M",
        "price": 17800
      },
      {
        "sku": "100032",
        "name": "17 12 SAT 3dB SAT -8...0dB",
        "ref": "JRM1712M",
        "price": 33100
      },
      {
        "sku": "100035",
        "name": "17 16 SAT -8dB SAT -8...0dB",
        "ref": "JRM1716M",
        "price": 38300
      },
      {
        "sku": "100036",
        "name": "17 8 SAT -2dB SAT -8...0dB",
        "ref": "JRM1708M",
        "price": 27300
      },
      {
        "sku": "237097",
        "name": "5 4 2 Ausgänge je 4 Receiver receivergespeist",
        "ref": "",
        "price": 15900
      },
      {
        "sku": "237084",
        "name": "5 4 2 Ausgänge je 4 Receiver Netzteil für LNB-",
        "ref": "",
        "price": 18200
      },
      {
        "sku": "014068",
        "name": "Mehrfachabzweiger,5 Stammleitungen (passiv),2 Abzweigergruppen,Dämpfung -10dB",
        "ref": "JMT0502-10A",
        "price": 6800
      },
      {
        "sku": "014069",
        "name": "Mehrfachabzweiger,5 Stammleitungen (passiv),2 Abzweigergruppen,Dämpfung -15dB",
        "ref": "JMT0502-15A",
        "price": 6800
      },
      {
        "sku": "014066",
        "name": "Mehrfachabzweiger,5 Stammleitungen (passiv),1 Abzweigergruppe,Dämpfung -10dB",
        "ref": "JMT0501-10A",
        "price": 5700
      },
      {
        "sku": "014067",
        "name": "Mehrfachabzweiger,5 Stammleitungen (passiv),1 Abzweigergruppe,Dämpfung -15dB",
        "ref": "JMT0501-15A",
        "price": 5700
      },
      {
        "sku": "014075",
        "name": "Breitband-Einfachabzweiger für Einkabelsysteme,-12dB Abzweig",
        "ref": "JPT01-12",
        "price": 1800
      },
      {
        "sku": "014072",
        "name": "Breitband-Einfachabzweiger für Einkabelsysteme,-17dB Abzweig",
        "ref": "JPT01-17",
        "price": 1800
      },
      {
        "sku": "015028",
        "name": "Mehrfachverteiler,5 Stammeingänge (passiv),2 Ausgangsgruppen,Dämpfung -5dB",
        "ref": "JMS0502A",
        "price": 5300
      },
      {
        "sku": "102017",
        "name": "SAT-Inline-Verstärker 5-862MHz -2dB,950-2200MHz +15dB;ferngespeist",
        "ref": "JAI0115",
        "price": 2100
      },
      {
        "sku": "102010",
        "name": "Kaskadenverstärker, , ,mittlere Ausgangsleistung,mit Netzteil",
        "ref": "JAL0825AN",
        "price": 22800
      },
      {
        "sku": "102007",
        "name": "Kaskadenverstärker, , ,mittlere Ausgangsleistung,mit Netzteil",
        "ref": "JAL0425AN",
        "price": 17600
      },
      {
        "sku": "102011",
        "name": "Kaskadenverstärker, , ,mittlere Ausgangsleistung,mit Netzteil",
        "ref": "JAL1625AN",
        "price": 37800
      }
    ]
  },
  {
    "title": "Einkabelsysteme JULTEC",
    "items": [
      {
        "sku": "237051",
        "name": "Einkabel-Kaskade 1 Satellit 1 Ausgang je 16 Receiver ohne Netzteil",
        "ref": "JPS0501-16M",
        "price": 11400
      },
      {
        "sku": "237093",
        "name": "Einkabel-Kaskade 1 Satellit 1 Ausgang je 8 Receiver receivergespeist",
        "ref": "JR0501-8M",
        "price": 9700
      },
      {
        "sku": "237094",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 1 Ausgang je 8 Receiver receivergespeist",
        "ref": "JRS0501-8T",
        "price": 9700
      },
      {
        "sku": "237052",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 1 Ausgang je 16 Receiver ohne Netzteil",
        "ref": "JPS0501-16T",
        "price": 11400
      },
      {
        "sku": "237082",
        "name": "Einkabel-Kaskade 1 Satellit 2 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JRS0502-8M",
        "price": 14900
      },
      {
        "sku": "237083",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 2 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JRS0502-8T",
        "price": 14900
      },
      {
        "sku": "237078",
        "name": "Einkabel-Kaskade 1 Satellit 4 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JRS0504-8M",
        "price": 27900
      },
      {
        "sku": "237043",
        "name": "Einkabel-Kaskade 1 Satellit 6 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JRS0506-8M",
        "price": 39900
      },
      {
        "sku": "237044",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 6 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JRS0506-8T",
        "price": 39900
      },
      {
        "sku": "237046",
        "name": "Einkabel-Kaskade 1 Satellit 8 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JRS0508-8M",
        "price": 51500
      },
      {
        "sku": "237047",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 8 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JRS0508-8T",
        "price": 51500
      },
      {
        "sku": "237095",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 4 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JRS0504-8T",
        "price": 27900
      },
      {
        "sku": "237091",
        "name": "Einkabel-Kaskade 1 Satellit 8 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JRS0508-4M",
        "price": 45400
      },
      {
        "sku": "237090",
        "name": "Einkabel-Kaskade 1 Satellit 4 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JRS0504-4M",
        "price": 23200
      },
      {
        "sku": "237104",
        "name": "Einkabel-Kaskade 1 Satellit 6 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JRS0506-4M",
        "price": 35800
      },
      {
        "sku": "237092",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 8 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JRS0508-4T",
        "price": 45400
      },
      {
        "sku": "237055",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 4 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JRS0504-4T",
        "price": 23200
      },
      {
        "sku": "237101",
        "name": "Einkabel-Multischalter,terminiert 1 Satellit 6 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JRS0506-4T",
        "price": 35800
      },
      {
        "sku": "237098",
        "name": "2 Satelliten 4 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JPS0904-8M",
        "price": 44000
      },
      {
        "sku": "237033",
        "name": "2 Satelliten 2 Ausgänge je 16 Receiver ohne Netzteil",
        "ref": "JPS0902-16M",
        "price": 32500
      },
      {
        "sku": "237013",
        "name": "2 Satelliten 2 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JPS0902-8M",
        "price": 24200
      },
      {
        "sku": "237105",
        "name": "2 Satelliten 6 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JPS0906-8M",
        "price": 61600
      },
      {
        "sku": "237102",
        "name": "2 Satelliten 8 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JPS0908-8M",
        "price": 79200
      },
      {
        "sku": "237025",
        "name": "2 Satelliten 1 Ausgang 8 Receiver receivergespeist",
        "ref": "JPS0901-8M",
        "price": 18200
      },
      {
        "sku": "237031",
        "name": "2 Satelliten 1 Ausgang je 16 Receiver ohne Netzteil",
        "ref": "JPS0901-16MN",
        "price": 23200
      },
      {
        "sku": "237109",
        "name": "4 Satelliten 1 Ausgang 16 Receiver ohneNetzteil",
        "ref": "JPS1701-16MN",
        "price": 34600
      },
      {
        "sku": "237012",
        "name": "4 Satelliten 2 Ausgänge je 16 Receiver ohneNetzteil",
        "ref": "JPS1702-16MN",
        "price": 52200
      },
      {
        "sku": "237002",
        "name": "4 Satelliten 6 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JPS1706-4M",
        "price": 73200
      },
      {
        "sku": "237000",
        "name": "4 Satelliten 4 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JPS1704-4M",
        "price": 50800
      },
      {
        "sku": "237113",
        "name": "4 Satelliten 6 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JPS1706-8M",
        "price": 85100
      },
      {
        "sku": "237086",
        "name": "4 Satelliten 4 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JPS1704-8M",
        "price": 59800
      },
      {
        "sku": "237004",
        "name": "4 Satelliten 8 Ausgänge je 4 Receiver receivergespeist",
        "ref": "JPS1708-4M",
        "price": 92400
      },
      {
        "sku": "237110",
        "name": "4 Satelliten 8 Ausgänge je 8 Receiver receivergespeist",
        "ref": "JPS1708-8M",
        "price": 106900
      },
      {
        "sku": "059029",
        "name": "Schaltnetzteil,230V AC-> 19VDC 2A,2x F-Buchse",
        "ref": "JNT19-2000",
        "price": 5900
      },
      {
        "sku": "006015",
        "name": "Programmierbare Durchgangsdose für teilnehmergesteuerte Einkabelsysteme,10dB Abzweig",
        "ref": "JAP310TSD",
        "price": 1680
      },
      {
        "sku": "006017",
        "name": "Programmierbare Stichdose für teilnehmergesteuerte Einkabelsysteme,7dB Abzweig",
        "ref": "JAP307TSD",
        "price": 1680
      },
      {
        "sku": "006019",
        "name": "Programmierbare Durchgangsdose für teilnehmergesteuerte Einkabelsysteme,18dB Abzweig",
        "ref": "JAP318TSD",
        "price": 1680
      },
      {
        "sku": "006016",
        "name": "Programmieradapter für JAP-Antennedosen USB nach DiSEqCWandler",
        "ref": "JAP100",
        "price": 5000
      },
      {
        "sku": "006018",
        "name": "Programmierbare Durchgangsdose für teilnehmergesteuerte Einkabelsysteme,14dB Abzweig",
        "ref": "JAP314TSD",
        "price": 1680
      },
      {
        "sku": "006036",
        "name": "Durchschleifdose (diodenentkoppelt),18dB Abzweig",
        "ref": "JAP318TRS",
        "price": 796
      },
      {
        "sku": "006025",
        "name": "Stichdose",
        "ref": "JAD300TRS",
        "price": 710
      },
      {
        "sku": "006030",
        "name": "Durchschleifdose (diodenentkoppelt),14dB Abzweig",
        "ref": "JAP314TRS",
        "price": 796
      },
      {
        "sku": "006028",
        "name": "Durchschleifdose (diodenentkoppelt),10dB Abzweig",
        "ref": "JAD310TRS",
        "price": 796
      },
      {
        "sku": "006035",
        "name": "Enddose",
        "ref": "JAD307TRS",
        "price": 710
      },
      {
        "sku": "006023",
        "name": "Stichdose mit Modemanschluss,welche als einzige Dose einer Ableitung eingesetzt wird",
        "ref": "JAD400TRS",
        "price": 1030
      },
      {
        "sku": "237108",
        "name": "Optik nach Koax-Wandler",
        "ref": "JOL010290A",
        "price": 19300
      }
    ]
  },
  {
    "title": "SAT-Receiver (DVB-S)",
    "items": [
      {
        "sku": "039041",
        "name": "Einkabel-Kaskade 1 Satellit 1 x 12 Receiver",
        "ref": "EXE2512",
        "price": 29900
      },
      {
        "sku": "212041",
        "name": "UFS810 HDTV / DVB-S2-Receiver,schwarz (Kathrein)",
        "ref": "",
        "price": 6800
      },
      {
        "sku": "059001",
        "name": "Fernspeise-Netzteil 18V/650mA",
        "ref": "NCF18",
        "price": 3900
      },
      {
        "sku": "002079",
        "name": "Sat-Verstärker 5-2150MHz,5-862MHz -3dBVerstärkung,950-2150MHz 15dBVerstärkung",
        "ref": "VWS04",
        "price": 2500
      },
      {
        "sku": "110013",
        "name": "Durchschleifdose - Einkabelsystem,3-fach;10dB",
        "ref": "ESU33",
        "price": 1740
      },
      {
        "sku": "110014",
        "name": "Enddose - Einkabelsystem,3-fach,1dB",
        "ref": "ESU34",
        "price": 1740
      },
      {
        "sku": "166009",
        "name": "Konverter für zweiWidebandsignale auf vier SAT-ZF-Ebenen",
        "ref": "UWS24",
        "price": 12600
      }
    ]
  },
  {
    "title": "Unicable2 LNB",
    "items": [
      {
        "sku": "008093",
        "name": "BK-Hausanschlussverstärker mit integriertem Rückkanal,Verstärkung 40dB,Ausgangspegel 124dBµV",
        "ref": "HG40125",
        "price": 12900
      }
    ]
  },
  {
    "title": "BK- & Hausanschlussverstärker",
    "items": [
      {
        "sku": "008096",
        "name": "Hausanschluss-Verstärker 40dB,Rückweg aktiv/passiv (Kathrein)",
        "ref": "VOS43/RA",
        "price": 17000
      },
      {
        "sku": "008094",
        "name": "Hausanschluss-Verstärker 32dB,Rückweg aktiv/passiv (Kathrein)",
        "ref": "VOS32/RA1G",
        "price": 12300
      },
      {
        "sku": "008088",
        "name": "Hausanschluss-Verstärker inkl.Rückweg 40/34/30dB,F-Connectoren,ortsgespeist (Kathrein)",
        "ref": "VOS137/RA",
        "price": 24400
      },
      {
        "sku": "008089",
        "name": "Hausanschluss-Verstärker inkl.Rückweg 40/34/30dB,PG-11,ferngespeist (Kathrein)",
        "ref": "VOS139/RA",
        "price": 26900
      },
      {
        "sku": "008091",
        "name": "Flexibler Hausanschlussverstärker 30/40dB schaltbar,125dBµV,mit steckbarem Rückkanal,ferngespeist",
        "ref": "",
        "price": 24500
      },
      {
        "sku": "102021",
        "name": "Hausanschluss-Verstärker 32/40dB (Delta)",
        "ref": "LHE1040P",
        "price": 18300
      },
      {
        "sku": "102025",
        "name": "Hausanschlussverstärker 39dB",
        "ref": "BKE39PS-KDG",
        "price": 8900
      },
      {
        "sku": "102024",
        "name": "Hausanschlussverstärker 33dB",
        "ref": "BKE33PS-KDG",
        "price": 5900
      },
      {
        "sku": "016002",
        "name": "1-fach Abzweiger 1 x 16dB DC-Durchgang auf Stamm",
        "ref": "AS116",
        "price": 350
      },
      {
        "sku": "016004",
        "name": "2-fach Abzweiger 2 x 12dB DC-Durchgang auf Stamm",
        "ref": "AS212",
        "price": 480
      },
      {
        "sku": "016005",
        "name": "2-fach Abzweiger 2 x 16dB DC-Durchgang auf Stamm",
        "ref": "AS216",
        "price": 480
      },
      {
        "sku": "016001",
        "name": "1-fach Abzweiger 1 x 12dB DC-Durchgang auf Stamm",
        "ref": "AS112",
        "price": 350
      },
      {
        "sku": "016003",
        "name": "1-fach Abzweiger 1 x 20dB DC-Durchgang auf Stamm",
        "ref": "AS120",
        "price": 350
      },
      {
        "sku": "015005",
        "name": "8-fach F-Verteiler 11dB DC-Durchgang",
        "ref": "V8S",
        "price": 990
      },
      {
        "sku": "015004",
        "name": "6-fach F-Verteiler 10dB DC-Durchgang",
        "ref": "V6S",
        "price": 940
      },
      {
        "sku": "015003",
        "name": "3-fach F-Verteiler 6dB DC-Durchgang",
        "ref": "V3S",
        "price": 490
      },
      {
        "sku": "015002",
        "name": "2-fach F-Verteiler 3,5dB DC-Durchgang",
        "ref": "V2S",
        "price": 340
      },
      {
        "sku": "015001",
        "name": "4-fach F-Verteiler 8dB DC-Durchgang",
        "ref": "V4S",
        "price": 540
      },
      {
        "sku": "013002",
        "name": "3-fachVerteiler 6dB",
        "ref": "V3",
        "price": 450
      },
      {
        "sku": "013001",
        "name": "2-fachVerteiler 3,5dB",
        "ref": "V2",
        "price": 320
      },
      {
        "sku": "014008",
        "name": "2-fach Abzweiger 16dB",
        "ref": "A216",
        "price": 590
      },
      {
        "sku": "013005",
        "name": "8-fachVerteiler 11dB",
        "ref": "V8",
        "price": 820
      },
      {
        "sku": "013003",
        "name": "4-fachVerteiler 8dB",
        "ref": "V4",
        "price": 310
      },
      {
        "sku": "014003",
        "name": "1-fach Abzweiger 12dB",
        "ref": "A112",
        "price": 410
      },
      {
        "sku": "014009",
        "name": "2-fach Abzweiger 20dB",
        "ref": "A220",
        "price": 590
      },
      {
        "sku": "014006",
        "name": "2-fach Abzweiger 8,5dB",
        "ref": "A28",
        "price": 590
      },
      {
        "sku": "014007",
        "name": "2-fach Abzweiger 12dB",
        "ref": "A212",
        "price": 590
      },
      {
        "sku": "014004",
        "name": "1-fach Abzweiger 16dB",
        "ref": "A116",
        "price": 410
      },
      {
        "sku": "014010",
        "name": "4-fach Abzweiger 12-15dB",
        "ref": "A4",
        "price": 950
      },
      {
        "sku": "013004",
        "name": "6-fachVerteiler 10dB",
        "ref": "V6",
        "price": 510
      },
      {
        "sku": "014005",
        "name": "1-fach Abzweiger 20dB",
        "ref": "A120",
        "price": 410
      },
      {
        "sku": "014002",
        "name": "1-fach Abzweiger 8dB",
        "ref": "A18",
        "price": 410
      },
      {
        "sku": "014012",
        "name": "8-fach Abzweiger 12-20dB",
        "ref": "A8",
        "price": 1300
      },
      {
        "sku": "014011",
        "name": "6-fach Abzweiger 12-17dB",
        "ref": "A6",
        "price": 1150
      },
      {
        "sku": "013016",
        "name": "Aufsteckverteiler Fernsehen 3,5dB (ganzmetall)",
        "ref": "TV2",
        "price": 77
      },
      {
        "sku": "013017",
        "name": "Aufsteckverteiler Rundfunk 3,5dB (ganzmetall)",
        "ref": "RV2",
        "price": 77
      },
      {
        "sku": "142001",
        "name": "Hausübergabepunkt für Kabelanlagen 1000MHz - EVK60 (Kathrein)",
        "ref": "A8",
        "price": 1700
      }
    ]
  },
  {
    "title": "Verteiler & Abzweiger",
    "items": [
      {
        "sku": "132010",
        "name": "Aufputzrahmen (Kathrein)",
        "ref": "ESZ50",
        "price": 170
      },
      {
        "sku": "132012",
        "name": "Abdeckplatte 2-Loch (Kathrein)",
        "ref": "ESZ52",
        "price": 110
      },
      {
        "sku": "006002",
        "name": "3-Loch Stichdose - RF /TV / SAT - inkl.Deckel & Rahmen - DC-Durchgang",
        "ref": "SAT3E",
        "price": 390
      },
      {
        "sku": "006010",
        "name": "3-Loch Durchgangsdose DC - 13dB - RF /TV / SAT - inkl.Deckel & Rahmen - DC-Durchgang",
        "ref": "SAT3D/DC",
        "price": 430
      },
      {
        "sku": "006003",
        "name": "3-Loch Stammdose - 10dB - RF /TV / SAT - inkl.Deckel & Rahmen - DC-Trennung",
        "ref": "SAT3D",
        "price": 430
      },
      {
        "sku": "006007",
        "name": "4-Loch Stichdose -  RF /TV / 2 x SAT - inkl.Deckel und Rahmen - DC-Durchgang",
        "ref": "SAT4E",
        "price": 700
      },
      {
        "sku": "006013",
        "name": "3-Loch Stichdose - 4dB -  RF /TV / SAT - DC-Durchgang (Kathrein)",
        "ref": "ESD30",
        "price": 1050
      },
      {
        "sku": "006014",
        "name": "3-LochTwin-Stichdose - 1dB - RF /TV / SAT - (DC-Durchgang (Kathrein)",
        "ref": "ESD32",
        "price": 960
      },
      {
        "sku": "071011",
        "name": "4-Loch SAT-Multimedia-Dose für Anlagen mitTV,RF,DVB-S (S2)-und BK-Daten,inkl.Deckel & Rahmen",
        "ref": "GAD410S",
        "price": 1180
      },
      {
        "sku": "132009",
        "name": "Abschlusswiderstand,kapazitiv getrennt,für Stammleitung mit Fernspeisung",
        "ref": "R75KAP",
        "price": 89
      },
      {
        "sku": "132003",
        "name": "Abschlusswiderstand",
        "ref": "R75",
        "price": 26
      },
      {
        "sku": "132004",
        "name": "F-Abschlusswiderstand",
        "ref": "R75F",
        "price": 20
      },
      {
        "sku": "132013",
        "name": "Abschlusswiderstand,kapazitiv getrennt,für Stammleitung mit Fernspeisung (Kathrein)",
        "ref": "ERA14",
        "price": 170
      },
      {
        "sku": "132006",
        "name": "IEC-Abschlusswiderstand",
        "ref": "R75IEC",
        "price": 41
      },
      {
        "sku": "132005",
        "name": "F-Abschlusswiderstand,kapazitiv getrennt,für Stammleitung mit Fernspeisung",
        "ref": "R75FKAP",
        "price": 165
      },
      {
        "sku": "007010",
        "name": "2-Loch Durchgangsdosen RF 87,5-108 /TV 5-68 + 118-1000MHz  12dB",
        "ref": "FS12",
        "price": 920
      },
      {
        "sku": "007009",
        "name": "2-Loch Durchgangsdosen RF 87,5-108 /TV 5-68 + 118-1000MHz  7dB",
        "ref": "FS07",
        "price": 920
      },
      {
        "sku": "007013",
        "name": "Durchgangsdose 10dB",
        "ref": "AD10",
        "price": 420
      },
      {
        "sku": "007012",
        "name": "Durchgangsdose 8dB",
        "ref": "AD08",
        "price": 420
      },
      {
        "sku": "007011",
        "name": "Stichleitungsdose 4dB",
        "ref": "AD04",
        "price": 420
      },
      {
        "sku": "007016",
        "name": "Stichleitungsdose 1dB",
        "ref": "AD01",
        "price": 420
      },
      {
        "sku": "007014",
        "name": "Durchgangsdose 14dB",
        "ref": "AD14",
        "price": 420
      },
      {
        "sku": "007015",
        "name": "Durchgangsdose 18dB",
        "ref": "AD18",
        "price": 420
      },
      {
        "sku": "071005",
        "name": "2-Loch Durchgangsdose - RF /TV / SAT - 10dB (Triax)",
        "ref": "GEDU10",
        "price": 1080
      },
      {
        "sku": "071001",
        "name": "2-Loch Stichdose - RF /TV / SAT - DC-Durchgang  (Triax)",
        "ref": "EDU04F",
        "price": 920
      },
      {
        "sku": "071010",
        "name": "2-Loch Stichdose - 2x 4-2400MHz - RF /TV / SAT - DC-Durchgang (Kathrein)",
        "ref": "ESD84",
        "price": 830
      },
      {
        "sku": "071006",
        "name": "2-Loch Durchgangsdose - RF /TV / SAT -15dB (Triax)",
        "ref": "GEDU15",
        "price": 1080
      },
      {
        "sku": "071009",
        "name": "2-Loch Durchgangsdose - RF /TV / SAT -20dB (Triax)",
        "ref": "GEDU20",
        "price": 1080
      },
      {
        "sku": "042001",
        "name": "1,5m - Schirmungsdämpfung > 75dB",
        "ref": "A150",
        "price": 79
      },
      {
        "sku": "042004",
        "name": "5m - Schirmungsdämpfung > 75dB",
        "ref": "A500",
        "price": 149
      },
      {
        "sku": "042002",
        "name": "2,5m - Schirmungsdämpfung > 75dB",
        "ref": "A250",
        "price": 99
      },
      {
        "sku": "042018",
        "name": "10m - Schirmungsdämpfung > 75dB",
        "ref": "A1000",
        "price": 299
      },
      {
        "sku": "042010",
        "name": "2,5m - digitaltauglich,Schirmungsdämpfung > 80dB",
        "ref": "A250D",
        "price": 190
      },
      {
        "sku": "042009",
        "name": "7,5m - digitaltauglich,Schirmungsdämpfung > 80dB",
        "ref": "A750D",
        "price": 400
      },
      {
        "sku": "047001",
        "name": "F-Anschlusskabel - 1,5m - F-Schraubstecker,Schirmungsdämpfung > 75dB",
        "ref": "FA150",
        "price": 149
      },
      {
        "sku": "042007",
        "name": "1,5m - digitaltauglich,Schirmungsdämpfung > 80dB",
        "ref": "A150D",
        "price": 169
      },
      {
        "sku": "042005",
        "name": "7,5m - Schirmungsdämpfung > 75dB",
        "ref": "A750",
        "price": 219
      },
      {
        "sku": "047011",
        "name": "F-Anschlusskabel - 5m - F-Schraubstecker,Schirmungsdämpfung > 75dB",
        "ref": "FA500",
        "price": 250
      },
      {
        "sku": "042012",
        "name": "10m - digitaltauglich,Schirmungsdämpfung > 80dB",
        "ref": "A1000D",
        "price": 500
      },
      {
        "sku": "047002",
        "name": "F-Anschlusskabel - 2,5m - F-Schraubstecker,Schirmungsdämpfung > 75dB",
        "ref": "FA250",
        "price": 169
      },
      {
        "sku": "042011",
        "name": "5m - digitaltauglich,Schirmungsdämpfung > 80dB",
        "ref": "A500D",
        "price": 300
      },
      {
        "sku": "047008",
        "name": "F-Anschlusskabel - 2,5m - F-Quickstecker,Schirmungsdämpfung > 75dB",
        "ref": "FA250Q",
        "price": 169
      },
      {
        "sku": "047003",
        "name": "F-Anschlusskabel - 5m - F-Quickstecker,Schirmungsdämpfung > 75dB",
        "ref": "FA500Q",
        "price": 250
      },
      {
        "sku": "047004",
        "name": "F-Anschlusskabel - 1,5m - F-Quickstecker,Schirmungsdämpfung > 75dB",
        "ref": "FA150Q",
        "price": 149
      },
      {
        "sku": "051013",
        "name": "Nullmodem Kabel,9-polig Kupplung-Kupplung",
        "ref": "SUB09",
        "price": 199
      },
      {
        "sku": "051012",
        "name": "Serielle 9-polige Stecker-Kupplung",
        "ref": "SUB9",
        "price": 199
      },
      {
        "sku": "104003",
        "name": "HDMI-Kabel - 5m - mit 2x HDMI-Stecker,19polig,high-quality",
        "ref": "HDMI5",
        "price": 599
      },
      {
        "sku": "104009",
        "name": "HDMI-Kabel - 1,5m - mit 2x HDMI-Stecker,19polig,high-quality",
        "ref": "",
        "price": 229
      },
      {
        "sku": "104002",
        "name": "HDMI-Kabel - 3m - mit 2x HDMI-Stecker,19polig,high-quality",
        "ref": "HDMI3",
        "price": 399
      },
      {
        "sku": "104001",
        "name": "HDMI-Kabel - 2m - mit 2x HDMI-Stecker,19polig,high-quality",
        "ref": "HDMI2",
        "price": 349
      },
      {
        "sku": "047015",
        "name": "Jumperkabel 50cm - F-Quickstecker",
        "ref": "FA50CMQ",
        "price": 160
      },
      {
        "sku": "047013",
        "name": "Jumperkabel 35cm - F-Quickstecker",
        "ref": "FA35CMQ",
        "price": 140
      }
    ]
  },
  {
    "title": "Antennendosen, Antennenkabel",
    "items": [
      {
        "sku": "023002",
        "name": "F-Prüfstecker",
        "ref": "F11",
        "price": 77
      },
      {
        "sku": "023003",
        "name": "F-Winkelverbinder (F-Buchse auf F-Stecker)",
        "ref": "F12",
        "price": 61
      },
      {
        "sku": "023001",
        "name": "F-Doppelkupplung 26mm",
        "ref": "F10",
        "price": 23
      },
      {
        "sku": "023008",
        "name": "F-Stecker auf IEC-Stecker",
        "ref": "F18",
        "price": 61
      },
      {
        "sku": "023004",
        "name": "F-Doppelstecker",
        "ref": "F14",
        "price": 61
      },
      {
        "sku": "023009",
        "name": "F-Buchse auf BNC-Stecker",
        "ref": "F19",
        "price": 130
      },
      {
        "sku": "023034",
        "name": "F-Doppelbuchse - Doseneinbau - 180° gewinkelt",
        "ref": "F13",
        "price": 89
      },
      {
        "sku": "023006",
        "name": "F-Buchse auf IEC-Stecker",
        "ref": "F16",
        "price": 61
      },
      {
        "sku": "023007",
        "name": "F-Buchse auf IEC-Buchse",
        "ref": "F17",
        "price": 61
      },
      {
        "sku": "023005",
        "name": "F-Stecker auf IEC-Buchse",
        "ref": "F15",
        "price": 61
      },
      {
        "sku": "023015",
        "name": "F-Schnellverbinder Stecker / Stecker",
        "ref": "F20",
        "price": 80
      },
      {
        "sku": "023010",
        "name": "IEC-Doppelstecker (Adapter)",
        "ref": "IEDST",
        "price": 30
      },
      {
        "sku": "023011",
        "name": "IEC-Doppelkupplung (Adapter)",
        "ref": "IEDKU",
        "price": 30
      },
      {
        "sku": "024020",
        "name": "IEC-Winkelkupplung",
        "ref": "IWKU",
        "price": 50
      },
      {
        "sku": "024016",
        "name": "IEC-Kupplung,werkzeugfrei montierbar (Hirschmann)",
        "ref": "KOK1Z",
        "price": 129
      },
      {
        "sku": "023026",
        "name": "IEC-Schraubstecker (geschraubt)",
        "ref": "IST1",
        "price": 30
      },
      {
        "sku": "023027",
        "name": "IEC-Schraubkupplung (geschraubt)",
        "ref": "IEK1",
        "price": 30
      },
      {
        "sku": "024015",
        "name": "IEC-Stecker,werkzeugfrei montierbar (Hirschmann)",
        "ref": "KOS1Z",
        "price": 149
      },
      {
        "sku": "024017",
        "name": "IEC-Winkelstecker,werkzeugfrei montierbar (Hirschmann)",
        "ref": "KOSWI3",
        "price": 149
      },
      {
        "sku": "024019",
        "name": "IEC-Winkelstecker",
        "ref": "IWST",
        "price": 50
      },
      {
        "sku": "024018",
        "name": "IEC-Winkelkupplung,werkzeugfrei montierbar (Hirschmann)",
        "ref": "KOKWI3",
        "price": 129
      },
      {
        "sku": "024001",
        "name": "F-Aufdrehstecker 4 mm VPE 100 Stck.",
        "ref": "FST4",
        "price": 1100
      },
      {
        "sku": "024003",
        "name": "F-Aufdrehstecker 7 mm VPE 100 Stck.",
        "ref": "FST7",
        "price": 900
      },
      {
        "sku": "024002",
        "name": "F-Aufdrehstecker 6 mm VPE 100 Stck.",
        "ref": "FST6",
        "price": 1100
      },
      {
        "sku": "024005",
        "name": "F-Aufdrehstecker 5 mm VPE 100 Stck.",
        "ref": "FST5",
        "price": 1100
      },
      {
        "sku": "042014",
        "name": "F-Flachkabel Fensterdurchführung DC-2200MHz (ohne bohren)",
        "ref": "FDU",
        "price": 400
      },
      {
        "sku": "086105",
        "name": "5/8 Stecker auf IEC-Buchse mit Gewinde",
        "ref": "58M-IEC",
        "price": 500
      },
      {
        "sku": "086104",
        "name": "5/8 Stecker auf F-Buchse mit Gewinde",
        "ref": "58M-FF",
        "price": 300
      },
      {
        "sku": "086102",
        "name": "PG11 Stecker auf F-Buchse",
        "ref": "PG11MFF",
        "price": 349
      },
      {
        "sku": "086103",
        "name": "PG11 Stecker auf IEC-Buchse",
        "ref": "PG11M-IEC",
        "price": 500
      },
      {
        "sku": "086106",
        "name": "Stromversorgungsanschluss PG11 Stecker 47mm",
        "ref": "PG11MAC",
        "price": 1100
      },
      {
        "sku": "086107",
        "name": "5/8Verschraubung für Stromeinspeisung",
        "ref": "58MAC",
        "price": 1100
      },
      {
        "sku": "024009",
        "name": "F-Crimpstecker 4.9/8.4 für H126 Kabel",
        "ref": "FCR7H126",
        "price": 2900
      },
      {
        "sku": "024007",
        "name": "F-Crimpstecker 5.1/8.4 für H125 Kabel",
        "ref": "FCR7H125",
        "price": 2900
      },
      {
        "sku": "024004",
        "name": "F-Crimpstecker 1,1-1,6mm Innenleiter (2-teilig)",
        "ref": "FSTCR",
        "price": 97
      },
      {
        "sku": "024010",
        "name": "F-Crimpstecker 3.7/6.4 für H121 Kabel",
        "ref": "FCR5H121",
        "price": 3100
      },
      {
        "sku": "024026",
        "name": "F-Crimpstecker 3.2/5.6 für H123B Kabel (VPE 100 Stück)",
        "ref": "FCR4H123",
        "price": 3100
      },
      {
        "sku": "024008",
        "name": "F-Crimpstecker 7.6/11.7 für PRG11 (1-teilig)",
        "ref": "FCR11PRG11",
        "price": 129
      },
      {
        "sku": "066007",
        "name": "F-Absetzwerkzeug 3-stufig für 7mm-Kabel wie H125,H126",
        "ref": "FAW7",
        "price": 1700
      },
      {
        "sku": "066001",
        "name": "Crimpzange für F-Connectoren 7-10,5mm",
        "ref": "SA27",
        "price": 1900
      },
      {
        "sku": "066004",
        "name": "Crimpzange für F-Connectoren 5-7mm",
        "ref": "SA28",
        "price": 1900
      },
      {
        "sku": "066009",
        "name": "Kompressionszange für F-Connectoren",
        "ref": "COMP",
        "price": 2400
      },
      {
        "sku": "066010",
        "name": "Kompressionszange / Multiquetsch 7/11mm",
        "ref": "COMP2",
        "price": 2800
      },
      {
        "sku": "066005",
        "name": "Crimpzange (Cabelcon) für F-Connectoren",
        "ref": "CRP106F",
        "price": 3900
      },
      {
        "sku": "066006",
        "name": "F-Montagewerkzeug,zum Aufdrehen von F-Crimpsteckern",
        "ref": "FMW",
        "price": 890
      },
      {
        "sku": "024030",
        "name": "F-Kompressionsstecker 7mm für H125 Kabel oder SK11xx",
        "ref": "FCOMP-H125",
        "price": 4400
      },
      {
        "sku": "024032",
        "name": "F-Kompressionsstecker 7mm f r H126 Kabel oder SK11TRIxx",
        "ref": "FCOMP-H126",
        "price": 4400
      },
      {
        "sku": "024034",
        "name": "F-Kompressionsstecker 5mm f r H121 Kabel",
        "ref": "FCOMP-H121",
        "price": 4400
      },
      {
        "sku": "024033",
        "name": "F-Kompressionsstecker 11mm f r PRG11 Kabel",
        "ref": "FCOMP-PRG11",
        "price": 239
      },
      {
        "sku": "024035",
        "name": "Self-Install F-Stecker 7mm für SK11TRIxx,Dielektrikum 4.6mm",
        "ref": "FSTSI49",
        "price": 4200
      },
      {
        "sku": "024036",
        "name": "Self-Install F-Stecker 7mm f r SK11xx,Dielektrikum 4.8mm",
        "ref": "FSTSI51",
        "price": 4200
      }
    ]
  },
  {
    "title": "SAT-ZF-Verteilsysteme",
    "items": [
      {
        "sku": "086070",
        "name": "1ikx PRG 11 1nkx COAX4FB 1qkx 1skx 1.1 / 7.3 1.7 / 7.0 1.7 / 7.25 2.2 / 8.8 2.23 / 10.2 3.3 / 13.5 3.4 / 13.8 4.9 / 9.4 COAX3FB18 FM12 FM02 FM32 FM03 FM413 FM25 FM46",
        "ref": "FF12",
        "price": 1600
      },
      {
        "sku": "086019",
        "name": "PG11M12 PG11M02 PG11M32 PG11M03",
        "ref": "",
        "price": 1300
      },
      {
        "sku": "086047",
        "name": "Art.-Nr. 086047 — Bezeichnung lt. Katalog",
        "ref": "",
        "price": 1300
      },
      {
        "sku": "086097",
        "name": "5/8M12 5/8M32 5/8M03 5/8M02",
        "ref": "5/8MU12",
        "price": 1300
      },
      {
        "sku": "086057",
        "name": "Art.-Nr. 086057 — Bezeichnung lt. Katalog",
        "ref": "",
        "price": 1400
      },
      {
        "sku": "086094",
        "name": "SP12",
        "ref": "",
        "price": 3600
      },
      {
        "sku": "086098",
        "name": "SP32 1ikx PRG 11 1nkx COAX4FB 1qkx 1skx 1.1 / 7.3 1.7 / 7.0 1.7 / 7.25 2.2 / 8.8 2.23 / 10.2 3.3 / 13.5 3.4 / 13.8 4.9 / 9.4 COAX3FB18 ,--",
        "ref": "16",
        "price": 1800
      },
      {
        "sku": "086088",
        "name": "SP46",
        "ref": "",
        "price": 2900
      },
      {
        "sku": "086092",
        "name": "SP17",
        "ref": "",
        "price": 1800
      },
      {
        "sku": "086089",
        "name": "SP03",
        "ref": "",
        "price": 1800
      },
      {
        "sku": "086090",
        "name": "SP413",
        "ref": "",
        "price": 2400
      },
      {
        "sku": "017004",
        "name": "2 x 4,5mm Mantel - 2,95mm Dielektrikum - 0,65mm Innenleiter (weiß)",
        "ref": "DUO07",
        "price": 55
      },
      {
        "sku": "017007",
        "name": "5mm Mantel - Schirmung - 3,5mm Dielektrikum - 0,8mm Innenleiter (weiß)",
        "ref": "TWINAX",
        "price": 56
      },
      {
        "sku": "017002",
        "name": "4mm Mantel - 2,9mm Dielektrikum - 0,7mm Innenleiter (weiß)",
        "ref": "SMK07/29",
        "price": 31
      },
      {
        "sku": "017039",
        "name": "wie SK11TRI,jedoch schwarz",
        "ref": "SK11TRI100S",
        "price": 52
      },
      {
        "sku": "017040",
        "name": "wie SK11TRI,jedoch halogenfrei & flammwidrig (grau)",
        "ref": "SK11LSZH",
        "price": 52
      },
      {
        "sku": "117001",
        "name": "wie SEK16,jedoch mit 5mm Stahltrageseil (schwarz)",
        "ref": "SEK16TR",
        "price": 159
      },
      {
        "sku": "017003",
        "name": "10,1mm  Außenleiter -  7,3 Dielektrikum - 1,63mm Innenleiter (schwarz)",
        "ref": "SEK16",
        "price": 115
      },
      {
        "sku": "017041",
        "name": "wie SEK16,jedoch halogenfrei & flammwidrig (grau)",
        "ref": "SEK16LSZH",
        "price": 120
      },
      {
        "sku": "145001",
        "name": "für 4mm Kabeldurchmesser mit 20mm Stahlnadel -VPE 100",
        "ref": "KS4/20",
        "price": 249
      },
      {
        "sku": "145004",
        "name": "für 6mm Kabeldurchmesser mit 35mm Stahlnadel -VPE 100",
        "ref": "KS6/35",
        "price": 249
      },
      {
        "sku": "145006",
        "name": "für 9mm Kabeldurchmesser mit 35mm Stahlnadel -VPE 100",
        "ref": "KS9/35",
        "price": 299
      },
      {
        "sku": "145002",
        "name": "für 6mm Kabeldurchmesser mit 25mm Stahlnadel -VPE 100",
        "ref": "KS6/25",
        "price": 249
      },
      {
        "sku": "145003",
        "name": "für 7mm Kabeldurchmesser mit 25mm Stahlnadel -VPE 100",
        "ref": "KS7/25",
        "price": 249
      },
      {
        "sku": "145005",
        "name": "für 7mm Kabeldurchmesser mit 35mm Stahlnadel -VPE 100",
        "ref": "KS7/35",
        "price": 249
      },
      {
        "sku": "145011",
        "name": "Kabelband (UV-beständig,schwarz) 4,8 x 280mm -VPE 100",
        "ref": "KB48280S",
        "price": 399
      },
      {
        "sku": "145008",
        "name": "Kabelband (natur) 2,5 x 100mm -VPE 100",
        "ref": "KB25100N",
        "price": 99
      },
      {
        "sku": "145012",
        "name": "Kabelband (UV-beständig,schwarz) 7,8 x 360mm -VPE 100",
        "ref": "KB78360S",
        "price": 999
      },
      {
        "sku": "145007",
        "name": "Kabelband (UV-beständig,schwarz) 2,5 x 100mm -VPE 100",
        "ref": "KB25100S",
        "price": 99
      },
      {
        "sku": "145009",
        "name": "Kabelband (UV-beständig,schwarz) 4,8 x 178mm -VPE 100",
        "ref": "KB48178S",
        "price": 299
      },
      {
        "sku": "017025",
        "name": "vergleichbar mit 1 NKX COAX4FB",
        "ref": "",
        "price": 209
      }
    ]
  },
  {
    "title": "Kabel",
    "items": [
      {
        "sku": "035003",
        "name": "Aufsteck-Einschleußweiche,Eingang 1 LMKU / Eingang 2 Band I-V (Astro)",
        "ref": "ASW600",
        "price": 3200
      },
      {
        "sku": "035004",
        "name": "Eingang 1 0-450MHz / Eingang 2 UHF 470-862MHz (Astro)",
        "ref": "HMW13",
        "price": 2900
      },
      {
        "sku": "012009",
        "name": "UKW-Profi-Ringdipol",
        "ref": "UKS2",
        "price": 2400
      },
      {
        "sku": "012005",
        "name": "UKW-Antenne,5 Elemente,Mastdurchmesser bis 60mm (Funke)",
        "ref": "UKA5",
        "price": 2300
      },
      {
        "sku": "012007",
        "name": "UKW-Antenne,3 Elemente,Mastdurchmesser bis 60mm (Triax)",
        "ref": "FM3",
        "price": 4800
      },
      {
        "sku": "012006",
        "name": "UKW-Antenne,7 Elemente,Mastdurchmesser bis 60mm (Funke)",
        "ref": "UKA7",
        "price": 4200
      },
      {
        "sku": "012012",
        "name": "UKW-DAB-Profi-Ringdipol",
        "ref": "UKSDAB",
        "price": 2900
      },
      {
        "sku": "012008",
        "name": "FM-Antenne Kreuzdipol (Kathrein)",
        "ref": "ABA20",
        "price": 5800
      },
      {
        "sku": "010004",
        "name": "UHF-Antenne,43 Elemente,K21-K69 (Funke)",
        "ref": "LAMBDA46",
        "price": 2200
      },
      {
        "sku": "010005",
        "name": "UHF-Antenne,LTE,15dB,K21-K69 (Triax)",
        "ref": "UNIX52",
        "price": 6900
      },
      {
        "sku": "010003",
        "name": "UHF-Antenne,91 Elemente,K21-K69 (Funke)",
        "ref": "LAMBDA90",
        "price": 3100
      },
      {
        "sku": "011003",
        "name": "VHF-/UHF-Kombi Antennte LTE700 (Triax)",
        "ref": "COMBI22",
        "price": 7900
      },
      {
        "sku": "062001",
        "name": "Erdungschelle 1 1/2 Zoll / 50mm",
        "ref": "ES50",
        "price": 175
      },
      {
        "sku": "062004",
        "name": "Erdungsbandschelle für Rohrdurchmesser 16-150 mm",
        "ref": "EBS1",
        "price": 280
      },
      {
        "sku": "062002",
        "name": "Erdungschelle 2 Zoll / 60 mm",
        "ref": "ES60",
        "price": 195
      },
      {
        "sku": "108010",
        "name": "Montagewinkel mit 11 F-Durchführungen",
        "ref": "MW11F",
        "price": 1300
      },
      {
        "sku": "108006",
        "name": "Erdungsblock F-F,2-fach",
        "ref": "EBL2",
        "price": 245
      },
      {
        "sku": "062003",
        "name": "Erdungschiene",
        "ref": "ES",
        "price": 355
      },
      {
        "sku": "108007",
        "name": "Montagewinkel mit 9 F-Durchführungen",
        "ref": "MW9F",
        "price": 990
      },
      {
        "sku": "108011",
        "name": "Montagewinkel mit 27 F-Durchführungen",
        "ref": "MW27F",
        "price": 2900
      },
      {
        "sku": "108009",
        "name": "Montagewinkel mit 13 F-Durchführungen",
        "ref": "MW13F",
        "price": 1400
      },
      {
        "sku": "108008",
        "name": "Montagewinkel mit 6 F-Durchführungen",
        "ref": "MW6F",
        "price": 420
      },
      {
        "sku": "108005",
        "name": "Erdungsblock F-F,1-fach",
        "ref": "EBL1",
        "price": 153
      },
      {
        "sku": "018003",
        "name": "Neopren Abdichtung für 32-60mm Rohrdurchmesser",
        "ref": "NP1",
        "price": 180
      },
      {
        "sku": "018006",
        "name": "Neopren Klebemanschette für Maste bis 60mm Rohrdurchmesser",
        "ref": "KM1",
        "price": 530
      },
      {
        "sku": "018007",
        "name": "Neopren Klebemanschette für Maste bis 76mm Rohrdurchmesser",
        "ref": "KM2",
        "price": 420
      },
      {
        "sku": "018018",
        "name": "Mastkappe für 48-60mm Rohrdurchmesser,stabile Ausführung,ZTC06 (Kathrein)",
        "ref": "MK2",
        "price": 300
      },
      {
        "sku": "018031",
        "name": "Mastkappe für 32-50mm Rohrdurchmesser",
        "ref": "MK1",
        "price": 100
      },
      {
        "sku": "018036",
        "name": "Mastkappe für 48-60mm Rohrdurchmesser,Kabeldurchführung,ZTC08 (Kathrein)",
        "ref": "MK4",
        "price": 440
      },
      {
        "sku": "018019",
        "name": "Mastkappe für 76mm Rohrdurchmesser",
        "ref": "MK3",
        "price": 100
      },
      {
        "sku": "018001",
        "name": "Bleidachhaube 300 x 400mm für Maste bis 60mm Rohrdurchmesser",
        "ref": "DH1",
        "price": 1600
      },
      {
        "sku": "018002",
        "name": "Bleidachhaube 350 x 400mm für Maste bis 76mm Rohrdurchmesser",
        "ref": "DH2",
        "price": 1700
      },
      {
        "sku": "018024",
        "name": "Bleidachhaube Reparaturset 350 x 400mm für Maste bis 60mm",
        "ref": "DH3R",
        "price": 1900
      },
      {
        "sku": "018009",
        "name": "Mastfuß bis 60mm Rohrdurchmesser",
        "ref": "MF1",
        "price": 450
      },
      {
        "sku": "018008",
        "name": "Mastfuß bis 60mm Rohrdurchmesser,stabile Ausführung",
        "ref": "MF2",
        "price": 750
      },
      {
        "sku": "018016",
        "name": "Mastfuß für 76mm Rohrdurchmesser",
        "ref": "MF3",
        "price": 1900
      },
      {
        "sku": "018039",
        "name": "Mastfuß für 110mm Rohrdurchmesser",
        "ref": "MF4",
        "price": 5900
      },
      {
        "sku": "018017",
        "name": "Vierloch-Mastbefestigungsschelle für 76mm Rohre",
        "ref": "MBS3",
        "price": 455
      },
      {
        "sku": "018010",
        "name": "Vierloch-Mastbefestigungsschelle für 48mm Rohre",
        "ref": "MBS1",
        "price": 200
      },
      {
        "sku": "018011",
        "name": "Vierloch-Mastbefestigungsschelle für 60mm Rohre",
        "ref": "MBS2",
        "price": 250
      },
      {
        "sku": "018038",
        "name": "Vierloch-Mastbefestigungsschelle für 110mm Rohre",
        "ref": "MBS4",
        "price": 2400
      },
      {
        "sku": "018015",
        "name": "Mastzubehör-Set 60mm bestehend aus:Dh1,NP1,MK2,MF2,MBS2",
        "ref": "MAZ60",
        "price": 3200
      },
      {
        "sku": "018014",
        "name": "Mastzubehör-Set 50mm bestehend aus:DH1,NP1,MK1,MF1,MBS1",
        "ref": "MAZ50",
        "price": 2600
      }
    ]
  },
  {
    "title": "Weichen & Kanalfilter",
    "items": [
      {
        "sku": "060007",
        "name": "50mm 30cm 25cm 15 x 15cm",
        "ref": "WHA50-30",
        "price": 1200
      },
      {
        "sku": "060006",
        "name": "50mm 18cm 25cm 15 x 15cm",
        "ref": "WHA50-18",
        "price": 900
      },
      {
        "sku": "060008",
        "name": "50mm 45cm 25cm 15 x 15cm",
        "ref": "WHA50-45",
        "price": 1300
      },
      {
        "sku": "060002",
        "name": "42mm 30cm 30cm 20 x 20cm",
        "ref": "WH42-30",
        "price": 1300
      },
      {
        "sku": "060016",
        "name": "60mm 50cm 40cm 25 x 25cm",
        "ref": "WH60-50",
        "price": 2800
      },
      {
        "sku": "060014",
        "name": "42mm 15cm 30cm 20 x 20cm",
        "ref": "WH42-15",
        "price": 1200
      },
      {
        "sku": "060001",
        "name": "30mm 30cm 20cm 13 x 10cm",
        "ref": "WH30-30",
        "price": 1100
      },
      {
        "sku": "060003",
        "name": "42mm 50cm 30cm 20 x 20cm",
        "ref": "WH42-50",
        "price": 1400
      },
      {
        "sku": "060010",
        "name": "42mm 25cm Vierbein Lochabst.25cm",
        "ref": "WH42-25V",
        "price": 1500
      },
      {
        "sku": "060020",
        "name": "50mm 100cm 35cm 30 x 30cm",
        "ref": "WH50-100",
        "price": 4900
      },
      {
        "sku": "060019",
        "name": "60mm 100cm 40cm 30 x 30cm",
        "ref": "WH60-100",
        "price": 4900
      },
      {
        "sku": "060005",
        "name": "76mm 40cm 50cm 30 x 30cm",
        "ref": "WH76-40",
        "price": 4900
      },
      {
        "sku": "060004",
        "name": "60mm 60cm 40cm 20 x 20cm",
        "ref": "WH60-60",
        "price": 2900
      },
      {
        "sku": "060017",
        "name": "76mm 75cm 40cm 30 x 30cm",
        "ref": "WH76-75",
        "price": 5900
      },
      {
        "sku": "019009",
        "name": "4m 2 x 2m 48 x 2,5mm 42 x 2mm",
        "ref": "SM448",
        "price": 6900
      },
      {
        "sku": "019001",
        "name": "6m 2 x 3m 48 x 2,5mm 42 x 2mm",
        "ref": "SM648",
        "price": 9900
      },
      {
        "sku": "019010",
        "name": "5m 2 x 2,5m 48 x 2,5mm 42 x 2mm",
        "ref": "SM548",
        "price": 8900
      },
      {
        "sku": "019021",
        "name": "3m 76mm 3mm",
        "ref": "STR376",
        "price": 5700
      },
      {
        "sku": "019005",
        "name": "2m 60mm 3,5mm",
        "ref": "STR260",
        "price": 2300
      },
      {
        "sku": "019008",
        "name": "2m 76mm 3mm",
        "ref": "STR276",
        "price": 3800
      },
      {
        "sku": "019004",
        "name": "3m 48mm 2mm",
        "ref": "STR348",
        "price": 2700
      },
      {
        "sku": "108003",
        "name": "1m 50mm 3mm",
        "ref": "MVL100",
        "price": 1600
      },
      {
        "sku": "019003",
        "name": "2m 48mm 2mm",
        "ref": "STR248",
        "price": 1900
      },
      {
        "sku": "019006",
        "name": "3m 60mm 3,5mm",
        "ref": "STR360",
        "price": 3300
      },
      {
        "sku": "019022",
        "name": "6m 76mm 3mm",
        "ref": "STR676",
        "price": 11400
      },
      {
        "sku": "019011",
        "name": "Mastlänge 2m, Rohr 48mm,2,5mmWandung",
        "ref": "STM248",
        "price": 3400
      }
    ]
  },
  {
    "title": "Terrestrische Antennen & Zubehör",
    "items": [
      {
        "sku": "115002",
        "name": "1 Platte 50x50cm für Rohre 40-60mm Länge:1m - 50mm",
        "ref": "BAFU50",
        "price": 3900
      },
      {
        "sku": "115001",
        "name": "1 Platte 40x60cm für Rohre 40-60mm Länge:1m - 50mm",
        "ref": "BAFU60",
        "price": 4900
      },
      {
        "sku": "115003",
        "name": "4 Platten 50x50cm für Rohre 76mm ----",
        "ref": "41",
        "price": 24900
      },
      {
        "sku": "018012",
        "name": "einfach 30mm 35cm 20cm 42-60mm",
        "ref": "AUSL30-35",
        "price": 2000
      },
      {
        "sku": "018037",
        "name": "einfach 42mm 50cm 30cm 42-76mm",
        "ref": "AUSL50-50-76",
        "price": 3000
      },
      {
        "sku": "018021",
        "name": "einfach 60mm 80cm 30cm 42-60mm",
        "ref": "AUSL60-80",
        "price": 4900
      },
      {
        "sku": "018028",
        "name": "einfach 76mm 50cm 30cm 76-90mm",
        "ref": "AUSL76-50",
        "price": 6600
      },
      {
        "sku": "018032",
        "name": "einfach 30mm 70cm 20cm 42-60mm",
        "ref": "AUSL30-70",
        "price": 2400
      },
      {
        "sku": "018029",
        "name": "einfach 42mm 50cm 30cm 42-60mm",
        "ref": "AUSL42-50",
        "price": 3000
      },
      {
        "sku": "018022",
        "name": "einfach 76mm 75cm 30cm 76-90mm",
        "ref": "AUSL76-75",
        "price": 8200
      },
      {
        "sku": "061003",
        "name": "Standfuß,Stahl,feuerverzinkt,klappbar 76mm 120cm",
        "ref": "STF3",
        "price": 11900
      },
      {
        "sku": "061001",
        "name": "Standfuß,Stahl,feuerverzinkt,klappbar 50mm 105cm",
        "ref": "STF1",
        "price": 3900
      },
      {
        "sku": "061002",
        "name": "Standfuß,Stahl,feuerverzinkt,klappbar 60mm 105cm",
        "ref": "STF2",
        "price": 4200
      },
      {
        "sku": "060023",
        "name": "Wandabstandshalter (Paar) 450mm 76mm",
        "ref": "WAH1004",
        "price": 8900
      },
      {
        "sku": "060012",
        "name": "Wandabstandshalter (Paar) 500mm 55mm",
        "ref": "WAH1003",
        "price": 3900
      },
      {
        "sku": "060018",
        "name": "Wandabstandshalter (Paar) 250mm 55mm",
        "ref": "WAH1001",
        "price": 2500
      },
      {
        "sku": "060011",
        "name": "Balkonhalter 100mm,für Rohrdurchmesser von 42mm (Paar)",
        "ref": "WAH7",
        "price": 1800
      },
      {
        "sku": "060009",
        "name": "Wandabstandshalter (Paar) 100mm 55mm",
        "ref": "WAH1002",
        "price": 1900
      },
      {
        "sku": "108001",
        "name": "Zwischen-Sparrenhalter 60-95cm 48mm 85cm",
        "ref": "ZSH1",
        "price": 4900
      },
      {
        "sku": "210004",
        "name": "Schiebesparrenhalter / Kathrein 52-85cm 60mm 120cm",
        "ref": "ZAS46",
        "price": 26900
      },
      {
        "sku": "210001",
        "name": "Schiebesparrenhalter / Kathrein 51-90cm 48mm 90cm",
        "ref": "ZAS40",
        "price": 9800
      },
      {
        "sku": "210002",
        "name": "Schiebesparrenhalter / Kathrein 51-90cm 48mm 130cm",
        "ref": "ZAS41",
        "price": 10600
      },
      {
        "sku": "108000",
        "name": "Schiebesparrenhalter 60-95cm 48mm 85cm",
        "ref": "SSH1",
        "price": 6500
      },
      {
        "sku": "108002",
        "name": "Schiebesparrenhalter 60-95cm 60mm 150cm",
        "ref": "SSH25",
        "price": 8500
      }
    ]
  },
  {
    "title": "Kopfstationstechnik (Steckkarten)",
    "items": [
      {
        "sku": "219000",
        "name": "UKW-Verstärker 42dB,6 Sperrkreise",
        "ref": "UVSK42P",
        "price": 12500
      },
      {
        "sku": "219002",
        "name": "DAB-/UKW-Verstärker 40dB,6 Sperrkreise",
        "ref": "UKDAB-6",
        "price": 16900
      },
      {
        "sku": "219001",
        "name": "DAB-/UKW-Verstärker 40dB",
        "ref": "UKDAB",
        "price": 9900
      },
      {
        "sku": "225000",
        "name": "Basisgerät mit 8 Steckplätzen,",
        "ref": "DH8-BASIS",
        "price": 45900
      },
      {
        "sku": "225006",
        "name": "Basisgerät mit 4 Steckplätzen,",
        "ref": "DH4-BASIS",
        "price": 28900
      },
      {
        "sku": "225002",
        "name": "Basisgerät mit 2 Steckplätzen,",
        "ref": "DH2-BASIS",
        "price": 19900
      },
      {
        "sku": "231002",
        "name": "Tablet zur Programmierung der Kopfstationen DHx-Basis und der Standalone-Geräte",
        "ref": "TABLET",
        "price": 18900
      },
      {
        "sku": "231003",
        "name": "Wifi-Adapter für serielle Schnittstelle zur Programmierung der Basisgeräte DHx-Basis und der Standalone-Geräte",
        "ref": "DH-WIFI",
        "price": 4500
      },
      {
        "sku": "230074",
        "name": "HDMI- Modul in 2x DVB-S 950-2150MHz",
        "ref": "DQ-HDMI4-S",
        "price": 129900
      },
      {
        "sku": "230062",
        "name": "HDMI Encoder,2x HDMI-Signal in QAM-HD,MPEG 4,Ausgang 47-862MHz",
        "ref": "DT-HDMI4-QAM",
        "price": 88900
      },
      {
        "sku": "230077",
        "name": "HDMI Encoder,HDMI-Signal in DVB-T HD,MPEG 4,Ausgangskanal 47-862MHz",
        "ref": "DS-HDMI4-T",
        "price": 73900
      },
      {
        "sku": "230058",
        "name": "4x DVB-S/S2Transponder in COFDM 47-862MHz,2 Nachbarkanal Paare / 1x CI",
        "ref": "DQ-S2-T",
        "price": 93900
      },
      {
        "sku": "230063",
        "name": "HDMI Encoder,4x HDMI-Signal in QAM-HD,MPEG 4,Ausgang 47-862MHz",
        "ref": "DQ-HDMI4-QAM",
        "price": 124900
      },
      {
        "sku": "230075",
        "name": "HDMI Encoder,2x HDMI-Signal in DVB-T HD,MPEG 4,Ausgangskanal 47-862MHz",
        "ref": "DT-HDMI4-T",
        "price": 93900
      },
      {
        "sku": "230073",
        "name": "HDMI- Modul in 1x DVB-S 950-2150MHz",
        "ref": "DT-HDMI4-S",
        "price": 103900
      },
      {
        "sku": "230061",
        "name": "HDMI Encoder,HDMI-Signal in QAM-HD,MPEG 4,Ausgangskanal 47-862MHz",
        "ref": "DS-HDMI4-QAM",
        "price": 73900
      },
      {
        "sku": "230060",
        "name": "2x DVB-S/S2Transponder in COFDM 47-862MHz,2 unabhängige Kanäle / 2x CI",
        "ref": "DT-S2-T-2CI",
        "price": 73900
      },
      {
        "sku": "230076",
        "name": "HDMI Encoder,4x HDMI-Signal in DVBT-HD,MPEG 4,Ausgangskanal 47-862MHz",
        "ref": "DQ-HDMI4-T",
        "price": 124900
      },
      {
        "sku": "230072",
        "name": "HDMI-Modul in 1x DVB-S 950-2150MHz",
        "ref": "DS-HDMI4-S",
        "price": 93900
      },
      {
        "sku": "099092",
        "name": "DVB-S/S2-Twin Modul, ,2x 8PSK / QPSK  950-2150MHz in DVB-S 950-2150MHz",
        "ref": "DT-S2-DVBS-2CI",
        "price": 84900
      },
      {
        "sku": "001278",
        "name": "ASTRA Low Band Diplexer zur Einschleusung von bis zu 5Transpondern im Bereich 950-1100MHz im AstraVL-Band",
        "ref": "LBD1100",
        "price": 8900
      },
      {
        "sku": "099093",
        "name": "DVB-S/S2-Twin Modul,1x CI,2x 8PSK / QPSK  950-2150MHz in DVB-S 950-2150MHz",
        "ref": "DT-S2-DVBS",
        "price": 72900
      },
      {
        "sku": "001286",
        "name": "ASTRA Low Band Diplexer zur Einschleusung von bis zu 6Transpondern im Bereich 950-1150MHz im AstraVL-Band",
        "ref": "LBD1150",
        "price": 9900
      },
      {
        "sku": "099095",
        "name": "T2C-Twin-Modul  47-862MHz in DVB-S 950-2150MHz,",
        "ref": "DT-T2-DVBS-2CI",
        "price": 84900
      },
      {
        "sku": "099094",
        "name": "T2C-Twin Modul  47-862MHz in DVB-S 950-2150MHz,1x CI",
        "ref": "DT-T2-DVBS",
        "price": 79900
      },
      {
        "sku": "230055",
        "name": "2x DVB-S/S2Transponder in QAM 47-862MHz,2 unabhängige Kanäle / 2x CI",
        "ref": "DT-S2-Q-2CI",
        "price": 65900
      },
      {
        "sku": "230057",
        "name": "4x DVB-S/S2Transponder in QAM 47-862MHz,2 Nachbarkanalpaare / 1x CI",
        "ref": "DQ-S2-Q",
        "price": 79900
      },
      {
        "sku": "230049",
        "name": "2x DVB-T/T2/C  in QAM,47-862MHz,2 unabhängige Kanäle,2x CI",
        "ref": "DT-T2CC-2CI",
        "price": 64900
      },
      {
        "sku": "230053",
        "name": "4x DVB-T/T2/C  in QAM,47-862MHz,D2 Nachbarkanalpaare, 1x CI",
        "ref": "DQ-T2CC",
        "price": 79900
      },
      {
        "sku": "230050",
        "name": "2x DVB-T/T2/C in COFDM,47-862MHz,2 unabhängige Kanäle,1x CI",
        "ref": "DT-T2CT",
        "price": 63900
      },
      {
        "sku": "230051",
        "name": "2x DVB-T/T2/C in COFDM,47-862MHz,2 unabhängige Kanäle,2x CI",
        "ref": "DT-T2CT-2CI",
        "price": 73900
      },
      {
        "sku": "230052",
        "name": "4x DVB-T/T2/C in COFDM,47-862MHz,2 Nachbarkanalpaare,1x CI",
        "ref": "DQ-T2CT",
        "price": 104900
      }
    ]
  },
  {
    "title": "Standalone Umsetzer",
    "items": [
      {
        "sku": "230070",
        "name": "HDMI Encoder,HDMI-Signal in DVB-S,MPEG 4",
        "ref": "HDMI4-4S",
        "price": 129900
      },
      {
        "sku": "099069",
        "name": "Twin-Umsetzer,2 x DVB-T/T2/C-Programmpakete in DVB-T (COFDM),2 unabhängige Kanäle 47-862MHz,1x CI",
        "ref": "T2/C-COFDM",
        "price": 78900
      },
      {
        "sku": "230069",
        "name": "HDMI Encoder,HDMI-Signal in DVB-S,MPEG 4",
        "ref": "HDMI4-2S",
        "price": 109900
      },
      {
        "sku": "099063",
        "name": "Twin-Umsetzer,2x DVB-S/S2Transponder in DVB-STransponder 910-2200MHz,1x CI",
        "ref": "",
        "price": 89900
      },
      {
        "sku": "099096",
        "name": "Umsetzer HDMI  in QAM oder DVB-T,MPEG2/4,Ausgangsfrequenz 50-8620MHz",
        "ref": "EM1HD",
        "price": 49900
      },
      {
        "sku": "230068",
        "name": "HDMI Encoder,HDMI-Signal in DVB-S,MPEG 4",
        "ref": "HDMI4-1S",
        "price": 84900
      },
      {
        "sku": "099064",
        "name": "Twin-Umsetzer,2 x DVB-T/T2/C-Programmpakete in DVB-C (QAM),2 unabhängige Kanäle 47-862MHz,1x CI",
        "ref": "T2/C-QAM",
        "price": 74900
      },
      {
        "sku": "099084",
        "name": "Twin-Umsetzer,2 x DVB-T/T2/C-Programmpakete in DVB-T (COFDM),2 unabhängige Kanäle 47-862MHz,2x CI",
        "ref": "T2/C-COFDM-2CI",
        "price": 89900
      },
      {
        "sku": "230067",
        "name": "HDMI Encoder,HDMI-Signal in COFDM,MPEG 4",
        "ref": "HDMI4-2T",
        "price": 88900
      },
      {
        "sku": "230078",
        "name": "HDMI Encoder,HDMI-Signal in COFDM,MPEG 4",
        "ref": "HDMI4-4T",
        "price": 128900
      },
      {
        "sku": "099088",
        "name": "Twin-Umsetzer,2 x DVB-T/T2/C-Programmpakete in DVB-C (QAM),2 unabhängige Kanäle 47-862MHz ,2x CI",
        "ref": "T2/C-QAM-2CI",
        "price": 84900
      },
      {
        "sku": "099062",
        "name": "Twin-Umsetzer,2 x DVB-T/T2/C-Programmpakete in DVB-STransponder 910-2200MHz,1 CI",
        "ref": "T2/C-DVBS",
        "price": 93900
      },
      {
        "sku": "099078",
        "name": "Twin-Umsetzer,2x DVB-S/S2-Transponder in DVB-STransponder 910-2200MHz,2x CI",
        "ref": "",
        "price": 124900
      },
      {
        "sku": "027044",
        "name": "AV-Modulator (Stereo),nachbarkanaltauglich,AV-Signal inTV-Kanal 47-862MHz",
        "ref": "USM3PC",
        "price": 21900
      },
      {
        "sku": "146033",
        "name": "AV-Rückkanal-Modulator,frei programmierbar 8,25-65MHz,nachbarkanaltauglich",
        "ref": "RKM3N",
        "price": 35900
      },
      {
        "sku": "027045",
        "name": "AV-Twin-Modulator (Stereo),nachbarkanaltgl.,2 x AV-Signal  in 2 xTV-Kanal 47-862MHz",
        "ref": "USMT4PC",
        "price": 38900
      },
      {
        "sku": "113002",
        "name": "FM-Stereo-Modulator 87-108MHz",
        "ref": "UFM3S",
        "price": 23900
      },
      {
        "sku": "230066",
        "name": "HDMI Encoder,HDMI-Signal in QAM-HD,MPEG 4",
        "ref": "HDMI4-1Q",
        "price": 71900
      },
      {
        "sku": "230064",
        "name": "HDMI Encoder,HDMI-Signal in QAM-HD,MPEG 4",
        "ref": "HDMI4-4Q",
        "price": 128900
      },
      {
        "sku": "099085",
        "name": "Twin-Umsetzer,2x DVB-S2-Programmpakete in QAM HD,2x CI Direct Conversion,47-862MHz",
        "ref": "S2-QAM-2CI",
        "price": 81900
      },
      {
        "sku": "099077",
        "name": "Quad-Umsetzer,4 DVB-S2-Programmpakete in COFDM,2 Nachbarkanal-Pärchen,47-862MHz",
        "ref": "S2-Q-COFDM",
        "price": 109900
      },
      {
        "sku": "230079",
        "name": "HDMI Encoder,HDMI-Signal in COFDM,MPEG 4",
        "ref": "HDMI4-1T",
        "price": 71900
      },
      {
        "sku": "230065",
        "name": "HDMI Encoder,HDMI-Signal in QAM-HD,MPEG 4",
        "ref": "HDMI4-2Q",
        "price": 88900
      },
      {
        "sku": "099049",
        "name": "QUAD-Umsetzer,4x DVB-S2-Programmpakete in QAM,2 Nachbarkanal-Pärchen 47-862MHz",
        "ref": "S2-QUAD",
        "price": 93900
      },
      {
        "sku": "099047",
        "name": "Twin-Umsetzer,2 DVB-S2-Programmpakete in COFDM,2 unabhängige Kanäle 47-862MHz",
        "ref": "S2-COFDM",
        "price": 74900
      },
      {
        "sku": "099083",
        "name": "Twin-Umsetzer,2x DVB-S2-Programmpakete in COFDM, 2 unabhängige Kanäle,47-862MHz",
        "ref": "S2-COFDM-2CI",
        "price": 92900
      },
      {
        "sku": "128005",
        "name": "Umsetzer UKW-Programm inTV-Kanal 47-862MHz,On-screen",
        "ref": "HR2FM",
        "price": 26900
      },
      {
        "sku": "128006",
        "name": "Twin-Umsetzer UKW-Programm inTV-Kanal 47-862MHz,On-Screen,",
        "ref": "",
        "price": 38900
      },
      {
        "sku": "099024",
        "name": "Demodulator 1TV-Kanal aus 47-862MHz in AV,Stereo",
        "ref": "SD3AV",
        "price": 19900
      }
    ]
  },
  {
    "title": "SAT in SAT-Umsetzer",
    "items": [
      {
        "sku": "001287",
        "name": "ASTRA Low Band Diplexer zur Einschleusung von bis zu 5Transpondern im Bereich 950-1200MHz im AstraVL-Band",
        "ref": "LBD1200",
        "price": 10900
      }
    ]
  },
  {
    "title": "Gehäuse & Schränke",
    "items": [
      {
        "sku": "005014",
        "name": "Außenschrank aus galvanisiertem Stahl,B 60 x H 80 xT 20cm,Montageplatte (Holz und Alu)",
        "ref": "BKSA4",
        "price": 18900
      },
      {
        "sku": "005015",
        "name": "Außenschrank aus galvanisiertem Stahl,B 60 x H 100 xT 20cm,Montageplatte (Holz und Alu)",
        "ref": "BKSA5",
        "price": 20900
      },
      {
        "sku": "005008",
        "name": "Außenschrank aus galvanisiertem Stahl mit Polyesterbeschichtung,Montageplatte (Holz und Alu) -Triax",
        "ref": "BKSA1",
        "price": 7500
      },
      {
        "sku": "005009",
        "name": "Außenschrank aus galvanisiertem Stahl mit Polyesterbeschichtung,Montageplatte (Holz und Alu) -Triax",
        "ref": "BKSA2",
        "price": 16900
      },
      {
        "sku": "005010",
        "name": "Außenschrank aus galvanisiertem Stahl mit Polyesterbeschichtung,Montageplatte (Holz und Alu) -Triax",
        "ref": "BKSA3",
        "price": 21900
      },
      {
        "sku": "005004",
        "name": "BKVerteilschrank,abschließbar,mit Rückwand - B 20 x H 20 xT 15cm",
        "ref": "BKS0",
        "price": 2500
      },
      {
        "sku": "005016",
        "name": "BKVerteilschrank,abschließbar,mit Rückwand - B 52 x H 35 xT 40cm - 19 Zoll",
        "ref": "BKS19",
        "price": 8900
      },
      {
        "sku": "005005",
        "name": "BKVerteilschrank,abschließbar,mit Rückwand - B 60 x H 80 xT 25cm",
        "ref": "BKS4",
        "price": 10900
      },
      {
        "sku": "005012",
        "name": "BKVerteilschrank,abschließbar,mit Rückwand - B 100 x H 80 xT 40cm",
        "ref": "BKS5",
        "price": 18900
      },
      {
        "sku": "005003",
        "name": "BKVerteilschrank,abschließbar,mit Rückwand - B 60 x H 40 xT 25cm",
        "ref": "BKS3",
        "price": 5500
      },
      {
        "sku": "005002",
        "name": "BKVerteilschrank,abschließbar,mit Rückwand - B 40 x H 40 xT 15cm",
        "ref": "BKS2",
        "price": 3900
      }
    ]
  },
  {
    "title": "Infokanal / Multimedia",
    "items": [
      {
        "sku": "053011",
        "name": "Infokanal zurWiedergabe von Powerpoint-,MPEG-,DIVX- und AVI-Dateien",
        "ref": "INFO-MICRO",
        "price": 33900
      }
    ]
  }
];

export const PRICE_ITEMS = PRICE_GROUPS.flatMap((g) => g.items.map((it) => ({ ...it, group: g.title })));
